import React from 'react';
import {IntlProvider, FormattedMessage, useIntl} from 'react-intl';

import {
  Label,
  Icon,
  Dropdown,
  Input
} from 'semantic-ui-react'

const CardDischargeTeachingUX = (props: any) => {
    return(
      <div
        id="CardDischargeTeachingUX-div-0"
        style={{padding: "10px"}}>
        <div
          id="CardDischargeTeachingUX-div-88"
          style={{display: "flex", justifyContent: "space-between"}}>

          <div
            id="CardDischargeTeachingUX-div-97"
            style={{display: "flex", alignItems: "center"}}>

            <div
              className="ui label yellow ribbon"
              id="CardDischargeTeachingUX-div-99">
              {props.languageUX === "en" ? "DISCHARGE TEACHING" : "การสอนการปลดประจำการ"}
            </div>
          </div>
          <div
            id="CardDischargeTeachingUX-div-98"
            style={{display: "flex"}}>

            <Label
              color="yellow"
              id="CardDischargeTeachingUX-Label-101"
              style={{display: props.showStatus ? "" : "none"}}>
              {props.languageUX === "en" ? "Draft" : "ร่าง"}
            </Label>
            <div
              id="CardDischargeTeachingUX-div-102"
              style={{cursor: "pointer", margin: "-5px -5px 0 15px", display: props.closeIcon ? "" : "none"}}>

              <Icon
                className="red large"
                id="CardDischargeTeachingUX-Icon-103"
                name={"close"}
                onClick={props.onClose}>
              </Icon>
            </div>
          </div>
        </div>
        <div
          id="CardDischargeTeachingUX-div-104"
          style={{paddingTop:"10px"}}>

          <div
            id="CardDischargeTeachingUX-div-119"
            style={{ display: "grid", gridTemplateColumns: "repeat(13, minmax(0, 1fr))", }}>

            <div
              id="CardDischargeTeachingUX-div-120"
              style={{ gridColumn: "1/3", fontWeight: "bold" ,display:"flex" }}>
              {props.languageUX === "en" ? "Patients and families receive education/advice." : "ผู้ป่วยและครอบครัวได้รับการสอน /คำแนะนำ"}
            </div>
            <div
              id="CardDischargeTeachingUX-div-121">
              {props.languageUX === "en" ? "Tutor" : "ผู้รับการสอน"}
            </div>
            <div
              id="CardDischargeTeachingUX-div-122">
              {props.languageUX === "en" ? "Recipient Name" : "ชื่อผู้รับ"}
            </div>
            <div
              id="CardDischargeTeachingUX-div-123">
              {props.languageUX === "en" ? "How to educate" : "วิธีการให้ความรู้"}
            </div>
            <div
              id="CardDischargeTeachingUX-div-124">
              {props.languageUX === "en" ? "Level of knowledge before teaching" : "ระดับความรู้ก่อนสอน"}
            </div>
            <div
              id="CardDischargeTeachingUX-div-125">
              {props.languageUX === "en" ? "Pre-Teaching Evaluator" : "ผู้ประเมินก่อนสอน"}
            </div>
            <div
              id="CardDischargeTeachingUX-div-126">
              ระดับความรู้สอนครั้งที่ 1
            </div>
            <div
              id="CardDischargeTeachingUX-div-127">
              ผู้ประเมินครั้งที่ 1
            </div>
            <div
              id="CardDischargeTeachingUX-div-128">
              {props.languageUX === "en" ? "Second teaching knowledge level" : "ระดับความรู้สอนครั้งที่ 2"}
            </div>
            <div
              id="CardDischargeTeachingUX-div-129">
              ผู้ประเมินครั้งที่ 2
            </div>
            <div
              id="CardDischargeTeachingUX-div-130">
              {props.languageUX === "en" ? "Knowledge level taught before going home" : "ระดับความรู้สอนก่อนกลับบ้าน"}
            </div>
            <div
              id="CardDischargeTeachingUX-div-131">
              {props.languageUX === "en" ? "Pre-home assessor" : "ผู้ประเมินก่อนกลับบ้าน"}
            </div>
            <div
              id="CardDischargeTeachingUX-div-132"
              style={{ gridColumn: "1/3", fontWeight: "bold" ,display:"flex" }}>
              {`1. ${props.ClinicalTermTeaching?.disc_teaching1?.name}`}
            </div>
            <div
              id="CardDischargeTeachingUX-div-133">

              <Dropdown
                allowAdditions={true}
                fluid={true}
                id="CardDischargeTeachingUX-Dropdown-134"
                multiple={true}
                name="relative"
                onAddItem={props.onAddOptions}
                onChange={props.handleChangeValue("disc_teaching1.main_relative")}
                options={props.options}
                search={true}
                selection={true}
                value={props.ClinicalTermTeaching?.disc_teaching1?.main_relative}>
              </Dropdown>
            </div>
            <div
              id="CardDischargeTeachingUX-div-135">

              <Input
                id="CardDischargeTeachingUX-Input-153"
                onChange={props.handleChangeValue("disc_teaching1.main_relative_name")}
                style={{width:"100%"}}
                value={props.ClinicalTermTeaching?.disc_teaching1?.main_relative_name}>
              </Input>
            </div>
            <div
              id="CardDischargeTeachingUX-div-136">

              <Dropdown
                allowAdditions={true}
                fluid={true}
                id="CardDischargeTeachingUX-Dropdown-145"
                multiple={true}
                name="method"
                onAddItem={props.onAddOptions}
                onChange={props.handleChangeValue("disc_teaching1.main_method")}
                options={props.optionsmethod}
                search={true}
                selection={true}
                value={props.ClinicalTermTeaching?.disc_teaching1?.main_method}>
              </Dropdown>
            </div>
            <div
              id="CardDischargeTeachingUX-div-137">

              <Dropdown
                allowAdditions={true}
                fluid={true}
                id="CardDischargeTeachingUX-Dropdown-146"
                multiple={true}
                name="knowledge"
                onAddItem={props.onAddOptions}
                onChange={props.handleChangeValue("disc_teaching1.main_before")}
                options={props.optionstype}
                search={true}
                selection={true}
                value={props.ClinicalTermTeaching?.disc_teaching1?.main_before}>
              </Dropdown>
            </div>
            <div
              id="CardDischargeTeachingUX-div-138">

              <Input
                id="CardDischargeTeachingUX-Input-455"
                onChange={props.handleChangeValue("disc_teaching1.main_before_user_name")}
                style={{width:"100%"}}
                value={props.ClinicalTermTeaching?.disc_teaching1?.main_before_user_name}>
              </Input>
            </div>
            <div
              id="CardDischargeTeachingUX-div-139">

              <Dropdown
                allowAdditions={true}
                fluid={true}
                id="CardDischargeTeachingUX-Dropdown-148"
                multiple={true}
                name="knowledge"
                onAddItem={props.onAddOptions}
                onChange={props.handleChangeValue("disc_teaching1.main_first")}
                options={props.optionstype}
                search={true}
                selection={true}
                value={props.ClinicalTermTeaching?.disc_teaching1?.main_first}>
              </Dropdown>
            </div>
            <div
              id="CardDischargeTeachingUX-div-140">

              <Input
                id="CardDischargeTeachingUX-Input-469"
                onChange={props.handleChangeValue("disc_teaching1.main_first_user_name")}
                style={{width:"100%"}}
                value={props.ClinicalTermTeaching?.disc_teaching1?.main_first_user_name}>
              </Input>
            </div>
            <div
              id="CardDischargeTeachingUX-div-141">

              <Dropdown
                allowAdditions={true}
                fluid={true}
                id="CardDischargeTeachingUX-Dropdown-150"
                multiple={true}
                name="knowledge"
                onAddItem={props.onAddOptions}
                onChange={props.handleChangeValue("disc_teaching1.main_second")}
                options={props.optionstype}
                search={true}
                selection={true}
                value={props.ClinicalTermTeaching?.disc_teaching1?.main_second}>
              </Dropdown>
            </div>
            <div
              id="CardDischargeTeachingUX-div-142">

              <Input
                id="CardDischargeTeachingUX-Input-483"
                onChange={props.handleChangeValue("disc_teaching1.main_second_user_name")}
                style={{width:"100%"}}
                value={props.ClinicalTermTeaching?.disc_teaching1?.main_second_user_name}>
              </Input>
            </div>
            <div
              id="CardDischargeTeachingUX-div-143">

              <Dropdown
                allowAdditions={true}
                fluid={true}
                id="CardDischargeTeachingUX-Dropdown-152"
                multiple={true}
                name="knowledge"
                onAddItem={props.onAddOptions}
                onChange={props.handleChangeValue("disc_teaching1.main_home")}
                options={props.optionstype}
                search={true}
                selection={true}
                value={props.ClinicalTermTeaching?.disc_teaching1?.main_home}>
              </Dropdown>
            </div>
            <div
              id="CardDischargeTeachingUX-div-154">

              <Input
                id="CardDischargeTeachingUX-Input-489"
                onChange={props.handleChangeValue("disc_teaching1.main_home_user_name")}
                style={{width:"100%"}}
                value={props.ClinicalTermTeaching?.disc_teaching1?.main_home_user_name}>
              </Input>
            </div>
            <div
              id="CardDischargeTeachingUX-div-156"
              style={{ gridColumn: "1/3" ,display:"flex" }}>
              {`- ${props.ClinicalTermTeaching?.disc_teaching1?.items?.[0]?.name}`}
            </div>
            <div
              id="CardDischargeTeachingUX-div-157">

              <Dropdown
                allowAdditions={true}
                fluid={true}
                id="CardDischargeTeachingUX-Dropdown-169"
                multiple={true}
                name="relative"
                onAddItem={props.onAddOptions}
                onChange={props.handleChangeValue("disc_teaching1.items.0.sub_relative")}
                options={props.options}
                search={true}
                selection={true}
                value={props.ClinicalTermTeaching?.disc_teaching1?.items?.[0]?.sub_relative}>
              </Dropdown>
            </div>
            <div
              id="CardDischargeTeachingUX-div-158">

              <Input
                id="CardDischargeTeachingUX-Input-168"
                onChange={props.handleChangeValue("disc_teaching1.items.0.sub_relative_name")}
                style={{width:"100%" }}
                value={props.ClinicalTermTeaching?.disc_teaching1?.items?.[0]?.sub_relative_name}>
              </Input>
            </div>
            <div
              id="CardDischargeTeachingUX-div-159">

              <Dropdown
                allowAdditions={true}
                fluid={true}
                id="CardDischargeTeachingUX-Dropdown-170"
                multiple={true}
                name="method"
                onAddItem={props.onAddOptions}
                onChange={props.handleChangeValue("disc_teaching1.items.0.sub_method")}
                options={props.optionsmethod}
                search={true}
                selection={true}
                value={props.ClinicalTermTeaching?.disc_teaching1?.items?.[0]?.sub_method}>
              </Dropdown>
            </div>
            <div
              id="CardDischargeTeachingUX-div-160">

              <Dropdown
                allowAdditions={true}
                fluid={true}
                id="CardDischargeTeachingUX-Dropdown-171"
                multiple={true}
                name="knowledge"
                onChange={props.handleChangeValue("disc_teaching1.items.0.sub_before")}
                options={props.optionstype}
                search={true}
                selection={true}
                value={props.ClinicalTermTeaching?.disc_teaching1?.items?.[0]?.sub_before}>
              </Dropdown>
            </div>
            <div
              id="CardDischargeTeachingUX-div-161">

              <Input
                id="CardDischargeTeachingUX-Input-456"
                onChange={props.handleChangeValue("disc_teaching1.items.0.sub_before_user_name")}
                style={{width:"100%"}}
                value={props.ClinicalTermTeaching?.disc_teaching1?.items?.[0]?.sub_before_user_name}>
              </Input>
            </div>
            <div
              id="CardDischargeTeachingUX-div-162">

              <Dropdown
                allowAdditions={true}
                fluid={true}
                id="CardDischargeTeachingUX-Dropdown-173"
                multiple={true}
                name="knowledge"
                onAddItem={props.onAddOptions}
                onChange={props.handleChangeValue("disc_teaching1.items.0.sub_first")}
                options={props.optionstype}
                search={true}
                selection={true}
                value={props.ClinicalTermTeaching?.disc_teaching1?.items?.[0]?.sub_first}>
              </Dropdown>
            </div>
            <div
              id="CardDischargeTeachingUX-div-163">

              <Input
                id="CardDischargeTeachingUX-Input-470"
                onChange={props.handleChangeValue("disc_teaching1.items.0.sub_first_user_name")}
                style={{width:"100%"}}
                value={props.ClinicalTermTeaching?.disc_teaching1?.items?.[0]?.sub_first_user_name}>
              </Input>
            </div>
            <div
              id="CardDischargeTeachingUX-div-164">

              <Dropdown
                allowAdditions={true}
                fluid={true}
                id="CardDischargeTeachingUX-Dropdown-175"
                multiple={true}
                name="knowledge"
                onAddItem={props.onAddOptions}
                onChange={props.handleChangeValue("disc_teaching1.items.0.sub_second")}
                options={props.optionstype}
                search={true}
                selection={true}
                value={props.ClinicalTermTeaching?.disc_teaching1?.items?.[0]?.sub_second}>
              </Dropdown>
            </div>
            <div
              id="CardDischargeTeachingUX-div-165">

              <Input
                id="CardDischargeTeachingUX-Input-484"
                onChange={props.handleChangeValue("disc_teaching1.items.0.sub_second_user_name")}
                style={{width:"100%"}}
                value={props.ClinicalTermTeaching?.disc_teaching1?.items?.[0]?.sub_second_user_name}>
              </Input>
            </div>
            <div
              id="CardDischargeTeachingUX-div-166">

              <Dropdown
                allowAdditions={true}
                fluid={true}
                id="CardDischargeTeachingUX-Dropdown-177"
                multiple={true}
                name="knowledge"
                onAddItem={props.onAddOptions}
                onChange={props.handleChangeValue("disc_teaching1.items.0.sub_home")}
                options={props.optionstype}
                selection={true}
                value={props.ClinicalTermTeaching?.disc_teaching1?.items?.[0]?.sub_home}>
              </Dropdown>
            </div>
            <div
              id="CardDischargeTeachingUX-div-167">

              <Input
                id="CardDischargeTeachingUX-Input-491"
                onChange={props.handleChangeValue("disc_teaching1.items.0.sub_home_user_name")}
                style={{width:"100%"}}
                value={props.ClinicalTermTeaching?.disc_teaching1?.items?.[0]?.sub_home_user_name}>
              </Input>
            </div>
            <div
              id="CardDischargeTeachingUX-div-179"
              style={{ gridColumn: "1/3" ,display:"flex" }}>
              {`- ${props.ClinicalTermTeaching?.disc_teaching1?.items?.[1]?.name}`}
            </div>
            <div
              id="CardDischargeTeachingUX-div-180">

              <Dropdown
                allowAdditions={true}
                fluid={true}
                id="CardDischargeTeachingUX-Dropdown-192"
                multiple={true}
                name="relative"
                onChange={props.handleChangeValue("disc_teaching1.items.1.sub_relative")}
                options={props.options}
                search={true}
                selection={true}
                value={props.ClinicalTermTeaching?.disc_teaching1?.items?.[1]?.sub_relative}>
              </Dropdown>
            </div>
            <div
              id="CardDischargeTeachingUX-div-181">

              <Input
                id="CardDischargeTeachingUX-Input-191"
                onChange={props.handleChangeValue("disc_teaching1.items.1.sub_relative_name")}
                style={{width:"100%"}}
                value={props.ClinicalTermTeaching?.disc_teaching1?.items?.[1]?.sub_relative_name}>
              </Input>
            </div>
            <div
              id="CardDischargeTeachingUX-div-182">

              <Dropdown
                allowAdditions={true}
                fluid={true}
                id="CardDischargeTeachingUX-Dropdown-193"
                multiple={true}
                name="method"
                onAddItem={props.onAddOptions}
                onChange={props.handleChangeValue("disc_teaching1.items.1.sub_method")}
                options={props.optionsmethod}
                search={true}
                selection={true}
                value={props.ClinicalTermTeaching?.disc_teaching1?.items?.[1]?.sub_method}>
              </Dropdown>
            </div>
            <div
              id="CardDischargeTeachingUX-div-183">

              <Dropdown
                allowAdditions={true}
                fluid={true}
                id="CardDischargeTeachingUX-Dropdown-194"
                multiple={true}
                name="knowledge"
                onAddItem={props.onAddOptions}
                onChange={props.handleChangeValue("disc_teaching1.items.1.sub_before")}
                options={props.optionstype}
                search={true}
                selection={true}
                value={props.ClinicalTermTeaching?.disc_teaching1?.items?.[1]?.sub_before}>
              </Dropdown>
            </div>
            <div
              id="CardDischargeTeachingUX-div-184">

              <Input
                id="CardDischargeTeachingUX-Input-457"
                onChange={props.handleChangeValue("disc_teaching1.items.1.sub_before_user_name")}
                style={{width:"100%"}}
                value={props.ClinicalTermTeaching?.disc_teaching1?.items?.[1]?.sub_before_user_name}>
              </Input>
            </div>
            <div
              id="CardDischargeTeachingUX-div-185">

              <Dropdown
                allowAdditions={true}
                fluid={true}
                id="CardDischargeTeachingUX-Dropdown-196"
                multiple={true}
                name="knowledge"
                onAddItem={props.onAddOptions}
                onChange={props.handleChangeValue("disc_teaching1.items.1.sub_first")}
                options={props.optionstype}
                search={true}
                selection={true}
                value={props.ClinicalTermTeaching?.disc_teaching1?.items?.[1]?.sub_first}>
              </Dropdown>
            </div>
            <div
              id="CardDischargeTeachingUX-div-186">

              <Input
                id="CardDischargeTeachingUX-Input-471"
                onChange={props.handleChangeValue("disc_teaching1.items.1.sub_first_user_name")}
                style={{width:"100%"}}
                value={props.ClinicalTermTeaching?.disc_teaching1?.items?.[1]?.sub_first_user_name}>
              </Input>
            </div>
            <div
              id="CardDischargeTeachingUX-div-187">

              <Dropdown
                allowAdditions={true}
                fluid={true}
                id="CardDischargeTeachingUX-Dropdown-198"
                multiple={true}
                name="knowledge"
                onAddItem={props.onAddOptions}
                onChange={props.handleChangeValue("disc_teaching1.items.1.sub_second")}
                options={props.optionstype}
                search={true}
                selection={true}
                value={props.ClinicalTermTeaching?.disc_teaching1?.items?.[1]?.sub_second}>
              </Dropdown>
            </div>
            <div
              id="CardDischargeTeachingUX-div-188">

              <Input
                id="CardDischargeTeachingUX-Input-485"
                onChange={props.handleChangeValue("disc_teaching1.items.1.sub_second_user_name")}
                style={{width:"100%"}}
                value={props.ClinicalTermTeaching?.disc_teaching1?.items?.[1]?.sub_second_user_name}>
              </Input>
            </div>
            <div
              id="CardDischargeTeachingUX-div-189">

              <Dropdown
                allowAdditions={true}
                fluid={true}
                id="CardDischargeTeachingUX-Dropdown-200"
                multiple={true}
                name="knowledge"
                onAddItem={props.onAddOptions}
                onChange={props.handleChangeValue("disc_teaching1.items.1.sub_home")}
                options={props.optionstype}
                search={true}
                selection={true}
                value={props.ClinicalTermTeaching?.disc_teaching1?.items?.[1]?.sub_home}>
              </Dropdown>
            </div>
            <div
              id="CardDischargeTeachingUX-div-190">

              <Input
                id="CardDischargeTeachingUX-Input-492"
                onChange={props.handleChangeValue("disc_teaching1.items.1.sub_home_user_name")}
                style={{width:"100%"}}
                value={props.ClinicalTermTeaching?.disc_teaching1?.items?.[1]?.sub_home_user_name}>
              </Input>
            </div>
            <div
              id="CardDischargeTeachingUX-div-202"
              style={{ gridColumn: "1/3" ,display:"flex" }}>
              {`- ${props.ClinicalTermTeaching?.disc_teaching1?.items?.[2]?.name}`}
            </div>
            <div
              id="CardDischargeTeachingUX-div-203">

              <Dropdown
                allowAdditions={true}
                fluid={true}
                id="CardDischargeTeachingUX-Dropdown-215"
                multiple={true}
                name="relative"
                onAddItem={props.onAddOptions}
                onChange={props.handleChangeValue("disc_teaching1.items.2.sub_relative")}
                options={props.options}
                search={true}
                selection={true}
                value={props.ClinicalTermTeaching?.disc_teaching1?.items?.[2]?.sub_relative}>
              </Dropdown>
            </div>
            <div
              id="CardDischargeTeachingUX-div-204">

              <Input
                id="CardDischargeTeachingUX-Input-214"
                onChange={props.handleChangeValue("disc_teaching1.items.2.sub_relative_name")}
                style={{width:"100%"}}
                value={props.ClinicalTermTeaching?.disc_teaching1?.items?.[2]?.sub_relative_name}>
              </Input>
            </div>
            <div
              id="CardDischargeTeachingUX-div-205">

              <Dropdown
                allowAdditions={true}
                fluid={true}
                id="CardDischargeTeachingUX-Dropdown-216"
                multiple={true}
                name="method"
                onAddItem={props.onAddOptions}
                onChange={props.handleChangeValue("disc_teaching1.items.2.sub_method")}
                options={props.optionsmethod}
                search={true}
                selection={true}
                value={props.ClinicalTermTeaching?.disc_teaching1?.items?.[2]?.sub_method}>
              </Dropdown>
            </div>
            <div
              id="CardDischargeTeachingUX-div-206">

              <Dropdown
                allowAdditions={true}
                fluid={true}
                id="CardDischargeTeachingUX-Dropdown-217"
                multiple={true}
                name="knowledge"
                onAddItem={props.onAddOptions}
                onChange={props.handleChangeValue("disc_teaching1.items.2.sub_before")}
                options={props.optionstype}
                search={true}
                selection={true}
                value={props.ClinicalTermTeaching?.disc_teaching1?.items?.[2]?.sub_before}>
              </Dropdown>
            </div>
            <div
              id="CardDischargeTeachingUX-div-207">

              <Input
                id="CardDischargeTeachingUX-Input-458"
                onChange={props.handleChangeValue("disc_teaching1.items.2.sub_before_user_name")}
                style={{width:"100%"}}
                value={props.ClinicalTermTeaching?.disc_teaching1?.items?.[2]?.sub_before_user_name}>
              </Input>
            </div>
            <div
              id="CardDischargeTeachingUX-div-208">

              <Dropdown
                allowAdditions={true}
                fluid={true}
                id="CardDischargeTeachingUX-Dropdown-219"
                multiple={true}
                name="knowledge"
                onAddItem={props.onAddOptions}
                onChange={props.handleChangeValue("disc_teaching1.items.2.sub_first")}
                options={props.optionstype}
                search={true}
                selection={true}
                value={props.ClinicalTermTeaching?.disc_teaching1?.items?.[2]?.sub_first}>
              </Dropdown>
            </div>
            <div
              id="CardDischargeTeachingUX-div-209">

              <Input
                id="CardDischargeTeachingUX-Input-472"
                onChange={props.handleChangeValue("disc_teaching1.items.2.sub_first_user_name")}
                style={{width:"100%"}}
                value={props.ClinicalTermTeaching?.disc_teaching1?.items?.[2]?.sub_first_user_name}>
              </Input>
            </div>
            <div
              id="CardDischargeTeachingUX-div-210">

              <Dropdown
                allowAdditions={true}
                fluid={true}
                id="CardDischargeTeachingUX-Dropdown-221"
                multiple={true}
                name="knowledge"
                onAddItem={props.onAddOptions}
                onChange={props.handleChangeValue("disc_teaching1.items.2.sub_second")}
                options={props.optionstype}
                search={true}
                selection={true}
                value={props.ClinicalTermTeaching?.disc_teaching1?.items?.[2]?.sub_second}>
              </Dropdown>
            </div>
            <div
              id="CardDischargeTeachingUX-div-211">

              <Input
                id="CardDischargeTeachingUX-Input-486"
                onChange={props.handleChangeValue("disc_teaching1.items.2.sub_second_user_name")}
                style={{width:"100%"}}
                value={props.ClinicalTermTeaching?.disc_teaching1?.items?.[2]?.sub_second_user_name}>
              </Input>
            </div>
            <div
              id="CardDischargeTeachingUX-div-212">

              <Dropdown
                defaultValue={true}
                fluid={true}
                id="CardDischargeTeachingUX-Dropdown-223"
                multiple={true}
                name="knowledge"
                onAddItem={props.onAddOptions}
                onChange={props.handleChangeValue("disc_teaching1.items.2.sub_home")}
                options={props.optionstype}
                search={true}
                selection={true}
                value={props.ClinicalTermTeaching?.disc_teaching1?.items?.[2]?.sub_home}>
              </Dropdown>
            </div>
            <div
              id="CardDischargeTeachingUX-div-213">

              <Input
                id="CardDischargeTeachingUX-Input-493"
                onChange={props.handleChangeValue("disc_teaching1.items.2.sub_home_user_name")}
                style={{width:"100%"}}
                value={props.ClinicalTermTeaching?.disc_teaching1?.items?.[2]?.sub_home_user_name}>
              </Input>
            </div>
            <div
              id="CardDischargeTeachingUX-div-225"
              style={{ gridColumn: "1/3", fontWeight: "bold" ,display:"flex" }}>
              {`2. ${props.ClinicalTermTeaching?.disc_teaching2?.name}`}
            </div>
            <div
              id="CardDischargeTeachingUX-div-226">

              <Dropdown
                allowAdditions={true}
                fluid={true}
                id="CardDischargeTeachingUX-Dropdown-238"
                multiple={true}
                name="relative"
                onAddItem={props.onAddOptions}
                onChange={props.handleChangeValue("disc_teaching2.main_relative")}
                options={props.options}
                search={true}
                selection={true}
                value={props.ClinicalTermTeaching?.disc_teaching2?.main_relative}>
              </Dropdown>
            </div>
            <div
              id="CardDischargeTeachingUX-div-227">

              <Input
                id="CardDischargeTeachingUX-Input-237"
                onChange={props.handleChangeValue("disc_teaching2.main_relative_name")}
                style={{width:"100%"}}
                value={props.ClinicalTermTeaching?.disc_teaching2?.main_relative_name}>
              </Input>
            </div>
            <div
              id="CardDischargeTeachingUX-div-228">

              <Dropdown
                allowAdditions={true}
                fluid={true}
                id="CardDischargeTeachingUX-Dropdown-239"
                multiple={true}
                name="method"
                onAddItem={props.onAddOptions}
                onChange={props.handleChangeValue("disc_teaching2.main_method")}
                options={props.optionsmethod}
                search={true}
                selection={true}
                value={props.ClinicalTermTeaching?.disc_teaching2?.main_method}>
              </Dropdown>
            </div>
            <div
              id="CardDischargeTeachingUX-div-229">

              <Dropdown
                allowAdditions={true}
                fluid={true}
                id="CardDischargeTeachingUX-Dropdown-240"
                multiple={true}
                name="knowledge"
                onAddItem={props.onAddOptions}
                onChange={props.handleChangeValue("disc_teaching2.main_before")}
                options={props.optionstype}
                search={true}
                selection={true}
                value={props.ClinicalTermTeaching?.disc_teaching2?.main_before}>
              </Dropdown>
            </div>
            <div
              id="CardDischargeTeachingUX-div-230">

              <Input
                id="CardDischargeTeachingUX-Input-459"
                onChange={props.handleChangeValue("disc_teaching2.main_before_user_name")}
                style={{width:"100%"}}
                value={props.ClinicalTermTeaching?.disc_teaching2?.main_before_user_name}>
              </Input>
            </div>
            <div
              id="CardDischargeTeachingUX-div-231">

              <Dropdown
                allowAdditions={true}
                fluid={true}
                id="CardDischargeTeachingUX-Dropdown-242"
                multiple={true}
                name="knowledge"
                onAddItem={props.onAddOptions}
                onChange={props.handleChangeValue("disc_teaching2.main_first")}
                options={props.optionstype}
                search={true}
                selection={true}
                value={props.ClinicalTermTeaching?.disc_teaching2?.main_first}>
              </Dropdown>
            </div>
            <div
              id="CardDischargeTeachingUX-div-232">

              <Input
                id="CardDischargeTeachingUX-Input-473"
                onChange={props.handleChangeValue("disc_teaching2.main_first_user_name")}
                style={{width:"100%"}}
                value={props.ClinicalTermTeaching?.disc_teaching2?.main_first_user_name}>
              </Input>
            </div>
            <div
              id="CardDischargeTeachingUX-div-233">

              <Dropdown
                allowAdditions={true}
                fluid={true}
                id="CardDischargeTeachingUX-Dropdown-244"
                multiple={true}
                name="knowledge"
                onAddItem={props.onAddOptions}
                onChange={props.handleChangeValue("disc_teaching2.main_second")}
                options={props.optionstype}
                search={true}
                selection={true}
                value={props.ClinicalTermTeaching?.disc_teaching2?.main_second}>
              </Dropdown>
            </div>
            <div
              id="CardDischargeTeachingUX-div-234">

              <Input
                id="CardDischargeTeachingUX-Input-487"
                onChange={props.handleChangeValue("disc_teaching2.main_second_user_name")}
                style={{width:"100%"}}
                value={props.ClinicalTermTeaching?.disc_teaching2?.main_second_user_name}>
              </Input>
            </div>
            <div
              id="CardDischargeTeachingUX-div-235">

              <Dropdown
                allowAdditions={true}
                fluid={true}
                id="CardDischargeTeachingUX-Dropdown-246"
                multiple={true}
                name="knowledge"
                onAddItem={props.onAddOptions}
                onChange={props.handleChangeValue("disc_teaching2.main_home")}
                options={props.optionstype}
                search={true}
                selection={true}
                value={props.ClinicalTermTeaching?.disc_teaching2?.main_home}>
              </Dropdown>
            </div>
            <div
              id="CardDischargeTeachingUX-div-236">

              <Input
                id="CardDischargeTeachingUX-Input-503"
                onChange={props.handleChangeValue("disc_teaching2.main_home_user_name")}
                style={{width:"100%"}}
                value={props.ClinicalTermTeaching?.disc_teaching2?.main_home_user_name}>
              </Input>
            </div>
            <div
              id="CardDischargeTeachingUX-div-248"
              style={{ gridColumn: "1/3", fontWeight: "bold" ,display:"flex" }}>
              {`3. ${props.ClinicalTermTeaching?.disc_teaching3?.name}`}
            </div>
            <div
              id="CardDischargeTeachingUX-div-249">

              <Dropdown
                allowAdditions={true}
                fluid={true}
                id="CardDischargeTeachingUX-Dropdown-261"
                multiple={true}
                name="relative"
                onAddItem={props.onAddOptions}
                onChange={props.handleChangeValue("disc_teaching3.main_relative")}
                options={props.options}
                search={true}
                selection={true}
                value={props.ClinicalTermTeaching?.disc_teaching3?.main_relative}>
              </Dropdown>
            </div>
            <div
              id="CardDischargeTeachingUX-div-250">

              <Input
                id="CardDischargeTeachingUX-Input-260"
                onChange={props.handleChangeValue("disc_teaching3.main_relative_name")}
                style={{width:"100%"}}
                value={props.ClinicalTermTeaching?.disc_teaching3?.main_relative_name}>
              </Input>
            </div>
            <div
              id="CardDischargeTeachingUX-div-251">

              <Dropdown
                allowAdditions={true}
                fluid={true}
                id="CardDischargeTeachingUX-Dropdown-262"
                multiple={true}
                name="method"
                onAddItem={props.onAddOptions}
                onChange={props.handleChangeValue("disc_teaching3.main_method")}
                options={props.optionsmethod}
                search={true}
                selection={true}
                value={props.ClinicalTermTeaching?.disc_teaching3?.main_method}>
              </Dropdown>
            </div>
            <div
              id="CardDischargeTeachingUX-div-252">

              <Dropdown
                allowAdditions={true}
                fluid={true}
                id="CardDischargeTeachingUX-Dropdown-263"
                multiple={true}
                name="knowledge"
                onAddItem={props.onAddOptions}
                onChange={props.handleChangeValue("disc_teaching3.main_before")}
                options={props.optionstype}
                search={true}
                selection={true}
                value={props.ClinicalTermTeaching?.disc_teaching3?.main_before}>
              </Dropdown>
            </div>
            <div
              id="CardDischargeTeachingUX-div-253">

              <Input
                id="CardDischargeTeachingUX-Input-460"
                onChange={props.handleChangeValue("disc_teaching3.main_before_user_name")}
                style={{width:"100%"}}
                value={props.ClinicalTermTeaching?.disc_teaching3?.main_before_user_name}>
              </Input>
            </div>
            <div
              id="CardDischargeTeachingUX-div-254">

              <Dropdown
                allowAdditions={true}
                fluid={true}
                id="CardDischargeTeachingUX-Dropdown-265"
                multiple={true}
                name="knowledge"
                onAddItem={props.onAddOptions}
                onChange={props.handleChangeValue("disc_teaching3.main_first")}
                options={props.optionstype}
                search={true}
                selection={true}
                value={props.ClinicalTermTeaching?.disc_teaching3?.main_first}>
              </Dropdown>
            </div>
            <div
              id="CardDischargeTeachingUX-div-255">

              <Input
                id="CardDischargeTeachingUX-Input-474"
                onChange={props.handleChangeValue("disc_teaching3.main_first_user_name")}
                style={{width:"100%"}}
                value={props.ClinicalTermTeaching?.disc_teaching3?.main_first_user_name}>
              </Input>
            </div>
            <div
              id="CardDischargeTeachingUX-div-256">

              <Dropdown
                allowAdditions={true}
                fluid={true}
                id="CardDischargeTeachingUX-Dropdown-267"
                multiple={true}
                name="knowledge"
                onAddItem={props.onAddOptions}
                onChange={props.handleChangeValue("disc_teaching3.main_second")}
                options={props.optionstype}
                search={true}
                selection={true}
                value={props.ClinicalTermTeaching?.disc_teaching3?.main_second}>
              </Dropdown>
            </div>
            <div
              id="CardDischargeTeachingUX-div-257">

              <Input
                id="CardDischargeTeachingUX-Input-488"
                onChange={props.handleChangeValue("disc_teaching3.main_second_user_name")}
                style={{width:"100%"}}
                value={props.ClinicalTermTeaching?.disc_teaching3?.main_second_user_name}>
              </Input>
            </div>
            <div
              id="CardDischargeTeachingUX-div-258">

              <Dropdown
                allowAdditions={true}
                fluid={true}
                id="CardDischargeTeachingUX-Dropdown-269"
                multiple={true}
                name="knowledge"
                onAddItem={props.onAddOptions}
                onChange={props.handleChangeValue("disc_teaching3.main_home")}
                options={props.optionstype}
                search={true}
                selection={true}
                value={props.ClinicalTermTeaching?.disc_teaching3?.main_home}>
              </Dropdown>
            </div>
            <div
              id="CardDischargeTeachingUX-div-259">

              <Input
                id="CardDischargeTeachingUX-Input-504"
                onChange={props.handleChangeValue("disc_teaching3.main_home_user_name")}
                style={{width:"100%"}}
                value={props.ClinicalTermTeaching?.disc_teaching3?.main_home_user_name}>
              </Input>
            </div>
            <div
              id="CardDischargeTeachingUX-div-271"
              style={{ gridColumn: "1/3", fontWeight: "bold" ,display:"flex" }}>
              {`4. ${props.ClinicalTermTeaching?.disc_teaching4?.name}`}
            </div>
            <div
              id="CardDischargeTeachingUX-div-272">

              <Dropdown
                allowAdditions={true}
                fluid={true}
                id="CardDischargeTeachingUX-Dropdown-284"
                multiple={true}
                name="relative"
                onAddItem={props.onAddOptions}
                onChange={props.handleChangeValue("disc_teaching4.main_relative")}
                options={props.options}
                search={true}
                selection={true}
                value={props.ClinicalTermTeaching?.disc_teaching4?.main_relative}>
              </Dropdown>
            </div>
            <div
              id="CardDischargeTeachingUX-div-273">

              <Input
                id="CardDischargeTeachingUX-Input-283"
                onChange={props.handleChangeValue("disc_teaching4.main_relative_name")}
                style={{width:"100%"}}
                value={props.ClinicalTermTeaching?.disc_teaching4?.main_relative_name}>
              </Input>
            </div>
            <div
              id="CardDischargeTeachingUX-div-274">

              <Dropdown
                allowAdditions={true}
                fluid={true}
                id="CardDischargeTeachingUX-Dropdown-285"
                multiple={true}
                name="method"
                onAddItem={props.onAddOptions}
                onChange={props.handleChangeValue("disc_teaching4.main_method")}
                options={props.optionsmethod}
                search={true}
                selection={true}
                value={props.ClinicalTermTeaching?.disc_teaching4?.main_method}>
              </Dropdown>
            </div>
            <div
              id="CardDischargeTeachingUX-div-275">

              <Dropdown
                allowAdditions={true}
                fluid={true}
                id="CardDischargeTeachingUX-Dropdown-286"
                multiple={true}
                name="knowledge"
                onAddItem={props.onAddOptions}
                onChange={props.handleChangeValue("disc_teaching4.main_before")}
                options={props.optionstype}
                search={true}
                selection={true}
                value={props.ClinicalTermTeaching?.disc_teaching4?.main_before}>
              </Dropdown>
            </div>
            <div
              id="CardDischargeTeachingUX-div-276">

              <Input
                id="CardDischargeTeachingUX-Input-461"
                onChange={props.handleChangeValue("disc_teaching4.main_before_user_name")}
                style={{width:"100%"}}
                value={props.ClinicalTermTeaching?.disc_teaching4?.main_before_user_name}>
              </Input>
            </div>
            <div
              id="CardDischargeTeachingUX-div-278">

              <Dropdown
                allowAdditions={true}
                fluid={true}
                id="CardDischargeTeachingUX-Dropdown-289"
                multiple={true}
                name="knowledge"
                onAddItem={props.onAddOptions}
                onChange={props.handleChangeValue("disc_teaching4.main_first")}
                options={props.optionstype}
                search={true}
                selection={true}
                value={props.ClinicalTermTeaching?.disc_teaching4?.main_first}>
              </Dropdown>
            </div>
            <div
              id="CardDischargeTeachingUX-div-277">

              <Input
                id="CardDischargeTeachingUX-Input-475"
                onChange={props.handleChangeValue("disc_teaching4.main_first_user_name")}
                style={{width:"100%"}}
                value={props.ClinicalTermTeaching?.disc_teaching4?.main_first_user_name}>
              </Input>
            </div>
            <div
              id="CardDischargeTeachingUX-div-279">

              <Dropdown
                allowAdditions={true}
                fluid={true}
                id="CardDischargeTeachingUX-Dropdown-290"
                multiple={true}
                name="knowledge"
                onAddItem={props.onAddOptions}
                onChange={props.handleChangeValue("disc_teaching4.main_second")}
                options={props.optionstype}
                search={true}
                selection={true}
                value={props.ClinicalTermTeaching?.disc_teaching4?.main_second}>
              </Dropdown>
            </div>
            <div
              id="CardDischargeTeachingUX-div-280">

              <Input
                id="CardDischargeTeachingUX-Input-495"
                onChange={props.handleChangeValue("disc_teaching4.main_second_user_name")}
                style={{width:"100%"}}
                value={props.ClinicalTermTeaching?.disc_teaching4?.main_second_user_name}>
              </Input>
            </div>
            <div
              id="CardDischargeTeachingUX-div-281">

              <Dropdown
                allowAdditions={true}
                fluid={true}
                id="CardDischargeTeachingUX-Dropdown-291"
                multiple={true}
                name="knowledge"
                onAddItem={props.onAddOptions}
                onChange={props.handleChangeValue("disc_teaching4.main_home")}
                options={props.optionstype}
                search={true}
                selection={true}
                value={props.ClinicalTermTeaching?.disc_teaching4?.main_home}>
              </Dropdown>
            </div>
            <div
              id="CardDischargeTeachingUX-div-282">

              <Input
                id="CardDischargeTeachingUX-Input-505"
                onChange={props.handleChangeValue("disc_teaching4.main_home_user_name")}
                style={{width:"100%"}}
                value={props.ClinicalTermTeaching?.disc_teaching4?.main_home_user_name}>
              </Input>
            </div>
            <div
              id="CardDischargeTeachingUX-div-294"
              style={{ gridColumn: "1/3", fontWeight: "bold" ,display:"flex" }}>
              {`5. ${props.ClinicalTermTeaching?.disc_teaching5?.name}`}
            </div>
            <div
              id="CardDischargeTeachingUX-div-295">

              <Dropdown
                allowAdditions={true}
                fluid={true}
                id="CardDischargeTeachingUX-Dropdown-307"
                multiple={true}
                name="relative"
                onAddItem={props.onAddOptions}
                onChange={props.handleChangeValue("disc_teaching5.main_relative")}
                options={props.options}
                search={true}
                selection={true}
                value={props.ClinicalTermTeaching?.disc_teaching5?.main_relative}>
              </Dropdown>
            </div>
            <div
              id="CardDischargeTeachingUX-div-296">

              <Input
                id="CardDischargeTeachingUX-Input-306"
                onChange={props.handleChangeValue("disc_teaching5.main_relative_name")}
                style={{width:"100%"}}
                value={props.ClinicalTermTeaching?.disc_teaching5?.main_relative_name}>
              </Input>
            </div>
            <div
              id="CardDischargeTeachingUX-div-297">

              <Dropdown
                allowAdditions={true}
                fluid={true}
                id="CardDischargeTeachingUX-Dropdown-308"
                multiple={true}
                name="method"
                onAddItem={props.onAddOptions}
                onChange={props.handleChangeValue("disc_teaching5.main_method")}
                options={props.optionsmethod}
                search={true}
                selection={true}
                value={props.ClinicalTermTeaching?.disc_teaching5?.main_method}>
              </Dropdown>
            </div>
            <div
              id="CardDischargeTeachingUX-div-298">

              <Dropdown
                allowAdditions={true}
                fluid={true}
                id="CardDischargeTeachingUX-Dropdown-309"
                multiple={true}
                name="knowledge"
                onAddItem={props.onAddOptions}
                onChange={props.handleChangeValue("disc_teaching5.main_before")}
                options={props.optionstype}
                search={true}
                selection={true}
                value={props.ClinicalTermTeaching?.disc_teaching5?.main_before}>
              </Dropdown>
            </div>
            <div
              id="CardDischargeTeachingUX-div-299">

              <Input
                id="CardDischargeTeachingUX-Input-462"
                onChange={props.handleChangeValue("disc_teaching5.main_before_user_name")}
                style={{width:"100%"}}
                value={props.ClinicalTermTeaching?.disc_teaching5?.main_before_user_name}>
              </Input>
            </div>
            <div
              id="CardDischargeTeachingUX-div-300">

              <Dropdown
                allowAdditions={true}
                fluid={true}
                id="CardDischargeTeachingUX-Dropdown-311"
                multiple={true}
                name="knowledge"
                onAddItem={props.onAddOptions}
                onChange={props.handleChangeValue("disc_teaching5.main_first")}
                options={props.optionstype}
                search={true}
                selection={true}
                value={props.ClinicalTermTeaching?.disc_teaching5?.main_first}>
              </Dropdown>
            </div>
            <div
              id="CardDischargeTeachingUX-div-301">

              <Input
                id="CardDischargeTeachingUX-Input-476"
                onChange={props.handleChangeValue("disc_teaching5.main_first_user_name")}
                style={{width:"100%"}}
                value={props.ClinicalTermTeaching?.disc_teaching5?.main_first_user_name}>
              </Input>
            </div>
            <div
              id="CardDischargeTeachingUX-div-302">

              <Dropdown
                allowAdditions={true}
                fluid={true}
                id="CardDischargeTeachingUX-Dropdown-313"
                multiple={true}
                name="knowledge"
                onAddItem={props.onAddOptions}
                onChange={props.handleChangeValue("disc_teaching5.main_second")}
                options={props.optionstype}
                search={true}
                selection={true}
                value={props.ClinicalTermTeaching?.disc_teaching5?.main_second}>
              </Dropdown>
            </div>
            <div
              id="CardDischargeTeachingUX-div-303">

              <Input
                id="CardDischargeTeachingUX-Input-496"
                onChange={props.handleChangeValue("disc_teaching5.main_second_user_name")}
                style={{width:"100%"}}
                value={props.ClinicalTermTeaching?.disc_teaching5?.main_second_user_name}>
              </Input>
            </div>
            <div
              id="CardDischargeTeachingUX-div-304">

              <Dropdown
                allowAdditions={true}
                fluid={true}
                id="CardDischargeTeachingUX-Dropdown-315"
                multiple={true}
                name="knowledge"
                onAddItem={props.onAddOptions}
                onChange={props.handleChangeValue("disc_teaching5.main_home")}
                options={props.optionstype}
                search={true}
                selection={true}
                value={props.ClinicalTermTeaching?.disc_teaching5?.main_home}>
              </Dropdown>
            </div>
            <div
              id="CardDischargeTeachingUX-div-305">

              <Input
                id="CardDischargeTeachingUX-Input-506"
                onChange={props.handleChangeValue("disc_teaching5.main_home_user_name")}
                style={{width:"100%"}}
                value={props.ClinicalTermTeaching?.disc_teaching5?.main_home_user_name}>
              </Input>
            </div>
            <div
              id="CardDischargeTeachingUX-div-317"
              style={{ gridColumn: "1/3", fontWeight: "bold" ,display:"flex" }}>
              {`6. ${props.ClinicalTermTeaching?.disc_teaching6?.name}`}
            </div>
            <div
              id="CardDischargeTeachingUX-div-318">

              <Dropdown
                allowAdditions={true}
                fluid={true}
                id="CardDischargeTeachingUX-Dropdown-330"
                multiple={true}
                name="relative"
                onAddItem={props.onAddOptions}
                onChange={props.handleChangeValue("disc_teaching6.main_relative")}
                options={props.options}
                search={true}
                selection={true}
                value={props.ClinicalTermTeaching?.disc_teaching6?.main_relative}>
              </Dropdown>
            </div>
            <div
              id="CardDischargeTeachingUX-div-319">

              <Input
                id="CardDischargeTeachingUX-Input-329"
                onChange={props.handleChangeValue("disc_teaching6.main_relative_name")}
                style={{width:"100%"}}
                value={props.ClinicalTermTeaching?.disc_teaching6?.main_relative_name}>
              </Input>
            </div>
            <div
              id="CardDischargeTeachingUX-div-320">

              <Dropdown
                allowAdditions={true}
                fluid={true}
                id="CardDischargeTeachingUX-Dropdown-331"
                multiple={true}
                name="method"
                onAddItem={props.onAddOptions}
                onChange={props.handleChangeValue("disc_teaching6.main_method")}
                options={props.optionsmethod}
                search={true}
                selection={true}
                value={props.ClinicalTermTeaching?.disc_teaching6?.main_method}>
              </Dropdown>
            </div>
            <div
              id="CardDischargeTeachingUX-div-321">

              <Dropdown
                allowAdditions={true}
                fluid={true}
                id="CardDischargeTeachingUX-Dropdown-332"
                multiple={true}
                name="knowledge"
                onAddItem={props.onAddOptions}
                onChange={props.handleChangeValue("disc_teaching6.main_before")}
                options={props.optionstype}
                search={true}
                selection={true}
                value={props.ClinicalTermTeaching?.disc_teaching6?.main_before}>
              </Dropdown>
            </div>
            <div
              id="CardDischargeTeachingUX-div-322">

              <Input
                id="CardDischargeTeachingUX-Input-463"
                onChange={props.handleChangeValue("disc_teaching6.main_before_user_name")}
                style={{width:"100%"}}
                value={props.ClinicalTermTeaching?.disc_teaching6?.main_before_user_name}>
              </Input>
            </div>
            <div
              id="CardDischargeTeachingUX-div-323">

              <Dropdown
                allowAdditions={true}
                fluid={true}
                id="CardDischargeTeachingUX-Dropdown-334"
                multiple={true}
                name="knowledge"
                onAddItem={props.onAddOptions}
                onChange={props.handleChangeValue("disc_teaching6.main_first")}
                options={props.optionstype}
                search={true}
                selection={true}
                value={props.ClinicalTermTeaching?.disc_teaching6?.main_first}>
              </Dropdown>
            </div>
            <div
              id="CardDischargeTeachingUX-div-324">

              <Input
                id="CardDischargeTeachingUX-Input-477"
                onChange={props.handleChangeValue("disc_teaching6.main_first_user_name")}
                style={{width:"100%"}}
                value={props.ClinicalTermTeaching?.disc_teaching6?.main_first_user_name}>
              </Input>
            </div>
            <div
              id="CardDischargeTeachingUX-div-325">

              <Dropdown
                allowAdditions={true}
                fluid={true}
                id="CardDischargeTeachingUX-Dropdown-336"
                multiple={true}
                name="knowledge"
                onAddItem={props.onAddOptions}
                onChange={props.handleChangeValue("disc_teaching6.main_second")}
                options={props.optionstype}
                search={true}
                selection={true}
                value={props.ClinicalTermTeaching?.disc_teaching6?.main_second}>
              </Dropdown>
            </div>
            <div
              id="CardDischargeTeachingUX-div-326">

              <Input
                id="CardDischargeTeachingUX-Input-497"
                onChange={props.handleChangeValue("disc_teaching6.main_second_user_name")}
                style={{width:"100%"}}
                value={props.ClinicalTermTeaching?.disc_teaching6?.main_second_user_name}>
              </Input>
            </div>
            <div
              id="CardDischargeTeachingUX-div-327">

              <Dropdown
                allowAdditions={true}
                fluid={true}
                id="CardDischargeTeachingUX-Dropdown-338"
                multiple={true}
                name="knowledge"
                onAddItem={props.onAddOptions}
                onChange={props.handleChangeValue("disc_teaching6.main_home")}
                options={props.optionstype}
                search={true}
                selection={true}
                value={props.ClinicalTermTeaching?.disc_teaching6?.main_home}>
              </Dropdown>
            </div>
            <div
              id="CardDischargeTeachingUX-div-328">

              <Input
                id="CardDischargeTeachingUX-Input-507"
                onChange={props.handleChangeValue("disc_teaching6.main_home_user_name")}
                style={{width:"100%"}}
                value={props.ClinicalTermTeaching?.disc_teaching6?.main_home_user_name}>
              </Input>
            </div>
            <div
              id="CardDischargeTeachingUX-div-340"
              style={{ gridColumn: "1/3", fontWeight: "bold" ,display:"flex" }}>
              {`7. ${props.ClinicalTermTeaching?.disc_teaching7?.name}`}
            </div>
            <div
              id="CardDischargeTeachingUX-div-341">

              <Dropdown
                allowAdditions={true}
                fluid={true}
                id="CardDischargeTeachingUX-Dropdown-353"
                multiple={true}
                name="relative"
                onAddItem={props.onAddOptions}
                onChange={props.handleChangeValue("disc_teaching7.main_relative")}
                options={props.options}
                search={true}
                selection={true}
                value={props.ClinicalTermTeaching?.disc_teaching7?.main_relative}>
              </Dropdown>
            </div>
            <div
              id="CardDischargeTeachingUX-div-342">

              <Input
                id="CardDischargeTeachingUX-Input-352"
                onChange={props.handleChangeValue("disc_teaching7.main_relative_name")}
                style={{width:"100%"}}
                value={props.ClinicalTermTeaching?.disc_teaching7?.main_relative_name}>
              </Input>
            </div>
            <div
              id="CardDischargeTeachingUX-div-343">

              <Dropdown
                allowAdditions={true}
                fluid={true}
                id="CardDischargeTeachingUX-Dropdown-354"
                multiple={true}
                name="method"
                onAddItem={props.onAddOptions}
                onChange={props.handleChangeValue("disc_teaching7.main_method")}
                options={props.optionsmethod}
                search={true}
                selection={true}
                value={props.ClinicalTermTeaching?.disc_teaching7?.main_method}>
              </Dropdown>
            </div>
            <div
              id="CardDischargeTeachingUX-div-344">

              <Dropdown
                allowAdditions={true}
                fluid={true}
                id="CardDischargeTeachingUX-Dropdown-355"
                multiple={true}
                name="knowledge"
                onAddItem={props.onAddOptions}
                onChange={props.handleChangeValue("disc_teaching7.main_before")}
                options={props.optionstype}
                search={true}
                selection={true}
                value={props.ClinicalTermTeaching?.disc_teaching7?.main_before}>
              </Dropdown>
            </div>
            <div
              id="CardDischargeTeachingUX-div-345">

              <Input
                id="CardDischargeTeachingUX-Input-464"
                onChange={props.handleChangeValue("disc_teaching7.main_before_user_name")}
                style={{width:"100%"}}
                value={props.ClinicalTermTeaching?.disc_teaching7?.main_before_user_name}>
              </Input>
            </div>
            <div
              id="CardDischargeTeachingUX-div-346">

              <Dropdown
                allowAdditions={true}
                fluid={true}
                id="CardDischargeTeachingUX-Dropdown-357"
                multiple={true}
                name="knowledge"
                onAddItem={props.onAddOptions}
                onChange={props.handleChangeValue("disc_teaching7.main_first")}
                options={props.optionstype}
                search={true}
                selection={true}
                value={props.ClinicalTermTeaching?.disc_teaching7?.main_first}>
              </Dropdown>
            </div>
            <div
              id="CardDischargeTeachingUX-div-347">

              <Input
                id="CardDischargeTeachingUX-Input-478"
                onChange={props.handleChangeValue("disc_teaching7.main_first_user_name")}
                style={{width:"100%"}}
                value={props.ClinicalTermTeaching?.disc_teaching7?.main_first_user_name}>
              </Input>
            </div>
            <div
              id="CardDischargeTeachingUX-div-348">

              <Dropdown
                allowAdditions={true}
                fluid={true}
                id="CardDischargeTeachingUX-Dropdown-359"
                multiple={true}
                name="knowledge"
                onAddItem={props.onAddOptions}
                onChange={props.handleChangeValue("disc_teaching7.main_second")}
                options={props.optionstype}
                search={true}
                selection={true}
                value={props.ClinicalTermTeaching?.disc_teaching7?.main_second}>
              </Dropdown>
            </div>
            <div
              id="CardDischargeTeachingUX-div-349">

              <Input
                id="CardDischargeTeachingUX-Input-498"
                onChange={props.handleChangeValue("disc_teaching7.main_second_user_name")}
                style={{width:"100%"}}
                value={props.ClinicalTermTeaching?.disc_teaching7?.main_second_user_name}>
              </Input>
            </div>
            <div
              id="CardDischargeTeachingUX-div-350">

              <Dropdown
                allowAdditions={true}
                fluid={true}
                id="CardDischargeTeachingUX-Dropdown-361"
                multiple={true}
                name="knowledge"
                onAddItem={props.onAddOptions}
                onChange={props.handleChangeValue("disc_teaching7.main_home")}
                options={props.optionstype}
                search={true}
                selection={true}
                value={props.ClinicalTermTeaching?.disc_teaching7?.main_home}>
              </Dropdown>
            </div>
            <div
              id="CardDischargeTeachingUX-div-351">

              <Input
                id="CardDischargeTeachingUX-Input-508"
                onChange={props.handleChangeValue("disc_teaching7.main_home_user_name")}
                style={{width:"100%"}}
                value={props.ClinicalTermTeaching?.disc_teaching7?.main_home_user_name}>
              </Input>
            </div>
            <div
              id="CardDischargeTeachingUX-div-363"
              style={{ gridColumn: "1/3" ,display:"flex" }}>
              {`- ${props.ClinicalTermTeaching?.disc_teaching7?.items?.[0]?.name}`}
            </div>
            <div
              id="CardDischargeTeachingUX-div-364">

              <Dropdown
                allowAdditions={true}
                fluid={true}
                id="CardDischargeTeachingUX-Dropdown-376"
                multiple={true}
                name="relative"
                onAddItem={props.onAddOptions}
                onChange={props.handleChangeValue("disc_teaching7.items.0.sub_relative")}
                options={props.options}
                search={true}
                selection={true}
                value={props.ClinicalTermTeaching?.disc_teaching7?.items?.[0]?.sub_relative}>
              </Dropdown>
            </div>
            <div
              id="CardDischargeTeachingUX-div-365">

              <Input
                id="CardDischargeTeachingUX-Input-375"
                onChange={props.handleChangeValue("disc_teaching7.items.0.sub_relative_name")}
                style={{width:"100%"}}
                value={props.ClinicalTermTeaching?.disc_teaching7?.items?.[0]?.sub_relative_name}>
              </Input>
            </div>
            <div
              id="CardDischargeTeachingUX-div-366">

              <Dropdown
                allowAdditions={true}
                fluid={true}
                id="CardDischargeTeachingUX-Dropdown-377"
                multiple={true}
                name="method"
                onAddItem={props.onAddOptions}
                onChange={props.handleChangeValue("disc_teaching7.items.0.sub_method")}
                options={props.optionsmethod}
                search={true}
                selection={true}
                value={props.ClinicalTermTeaching?.disc_teaching7?.items?.[0]?.sub_method}>
              </Dropdown>
            </div>
            <div
              id="CardDischargeTeachingUX-div-367">

              <Dropdown
                allowAdditions={true}
                fluid={true}
                id="CardDischargeTeachingUX-Dropdown-378"
                multiple={true}
                name="knowledge"
                onAddItem={props.onAddOptions}
                onChange={props.handleChangeValue("disc_teaching7.items.0.sub_before")}
                options={props.optionstype}
                search={true}
                selection={true}
                value={props.ClinicalTermTeaching?.disc_teaching7?.items?.[0]?.sub_before}>
              </Dropdown>
            </div>
            <div
              id="CardDischargeTeachingUX-div-368">

              <Input
                id="CardDischargeTeachingUX-Input-465"
                onChange={props.handleChangeValue("disc_teaching7.items.0.sub_before_user_name")}
                style={{width:"100%"}}
                value={props.ClinicalTermTeaching?.disc_teaching7?.items?.[0]?.sub_before_user_name}>
              </Input>
            </div>
            <div
              id="CardDischargeTeachingUX-div-369">

              <Dropdown
                allowAdditions={true}
                fluid={true}
                id="CardDischargeTeachingUX-Dropdown-380"
                multiple={true}
                name="knowledge"
                onAddItem={props.onAddOptions}
                onChange={props.handleChangeValue("disc_teaching7.items.0.sub_first")}
                options={props.optionstype}
                search={true}
                selection={true}
                value={props.ClinicalTermTeaching?.disc_teaching7?.items?.[0]?.sub_first}>
              </Dropdown>
            </div>
            <div
              id="CardDischargeTeachingUX-div-370">

              <Input
                id="CardDischargeTeachingUX-Input-479"
                onChange={props.handleChangeValue("disc_teaching7.items.0.sub_first_user_name")}
                style={{width:"100%"}}
                value={props.ClinicalTermTeaching?.disc_teaching7?.items?.[0]?.sub_first_user_name}>
              </Input>
            </div>
            <div
              id="CardDischargeTeachingUX-div-371">

              <Dropdown
                allowAdditions={true}
                fluid={true}
                id="CardDischargeTeachingUX-Dropdown-382"
                multiple={true}
                name="knowledge"
                onAddItem={props.onAddOptions}
                onChange={props.handleChangeValue("disc_teaching7.items.0.sub_second")}
                options={props.optionstype}
                search={true}
                selection={true}
                value={props.ClinicalTermTeaching?.disc_teaching7?.items?.[0]?.sub_second}>
              </Dropdown>
            </div>
            <div
              id="CardDischargeTeachingUX-div-372">

              <Input
                id="CardDischargeTeachingUX-Input-499"
                onChange={props.handleChangeValue("disc_teaching7.items.0.sub_second_user_name")}
                style={{width:"100%"}}
                value={props.ClinicalTermTeaching?.disc_teaching7?.items?.[0]?.sub_second_user_name}>
              </Input>
            </div>
            <div
              id="CardDischargeTeachingUX-div-373">

              <Dropdown
                allowAdditions={true}
                fluid={true}
                id="CardDischargeTeachingUX-Dropdown-384"
                multiple={true}
                name="knowledge"
                onAddItem={props.onAddOptions}
                onChange={props.handleChangeValue("disc_teaching7.items.0.sub_home")}
                options={props.optionstype}
                search={true}
                selection={true}
                value={props.ClinicalTermTeaching?.disc_teaching7?.items?.[0]?.sub_home}>
              </Dropdown>
            </div>
            <div
              id="CardDischargeTeachingUX-div-374">

              <Input
                id="CardDischargeTeachingUX-Input-509"
                onChange={props.handleChangeValue("disc_teaching7.items.0.sub_home_user_name")}
                style={{width:"100%"}}
                value={props.ClinicalTermTeaching?.disc_teaching7?.items?.[0]?.sub_home_user_name}>
              </Input>
            </div>
            <div
              id="CardDischargeTeachingUX-div-386"
              style={{ gridColumn: "1/3" ,display:"flex" }}>
              {`- ${props.ClinicalTermTeaching?.disc_teaching7?.items?.[1]?.name}`}
            </div>
            <div
              id="CardDischargeTeachingUX-div-387">

              <Dropdown
                allowAdditions={true}
                fluid={true}
                id="CardDischargeTeachingUX-Dropdown-399"
                multiple={true}
                name="relative"
                onAddItem={props.onAddOptions}
                onChange={props.handleChangeValue("disc_teaching7.items.1.sub_relative")}
                options={props.options}
                search={true}
                selection={true}
                value={props.ClinicalTermTeaching?.disc_teaching7?.items?.[1]?.sub_relative}>
              </Dropdown>
            </div>
            <div
              id="CardDischargeTeachingUX-div-388">

              <Input
                id="CardDischargeTeachingUX-Input-398"
                onChange={props.handleChangeValue("disc_teaching7.items.1.sub_relative_name")}
                style={{width:"100%"}}
                value={props.ClinicalTermTeaching?.disc_teaching7?.items?.[1]?.sub_relative_name}>
              </Input>
            </div>
            <div
              id="CardDischargeTeachingUX-div-389">

              <Dropdown
                allowAdditions={true}
                fluid={true}
                id="CardDischargeTeachingUX-Dropdown-400"
                multiple={true}
                name="method"
                onAddItem={props.onAddOptions}
                onChange={props.handleChangeValue("disc_teaching7.items.1.sub_method")}
                options={props.optionsmethod}
                search={true}
                selection={true}
                value={props.ClinicalTermTeaching?.disc_teaching7?.items?.[1]?.sub_method}>
              </Dropdown>
            </div>
            <div
              id="CardDischargeTeachingUX-div-390">

              <Dropdown
                allowAdditions={true}
                fluid={true}
                id="CardDischargeTeachingUX-Dropdown-401"
                multiple={true}
                name="knowledge"
                onAddItem={props.onAddOptions}
                onChange={props.handleChangeValue("disc_teaching7.items.1.sub_before")}
                options={props.optionstype}
                search={true}
                selection={true}
                value={props.ClinicalTermTeaching?.disc_teaching7?.items?.[1]?.sub_before}>
              </Dropdown>
            </div>
            <div
              id="CardDischargeTeachingUX-div-391">

              <Input
                id="CardDischargeTeachingUX-Input-466"
                onChange={props.handleChangeValue("disc_teaching7.items.1.sub_before_user_name")}
                style={{width:"100%"}}
                value={props.ClinicalTermTeaching?.disc_teaching7?.items?.[1]?.sub_before_user_name}>
              </Input>
            </div>
            <div
              id="CardDischargeTeachingUX-div-392">

              <Dropdown
                allowAdditions={true}
                fluid={true}
                id="CardDischargeTeachingUX-Dropdown-403"
                multiple={true}
                name="knowledge"
                onAddItem={props.onAddOptions}
                onChange={props.handleChangeValue("disc_teaching7.items.1.sub_first")}
                options={props.optionstype}
                search={true}
                selection={true}
                value={props.ClinicalTermTeaching?.disc_teaching7?.items?.[1]?.sub_first}>
              </Dropdown>
            </div>
            <div
              id="CardDischargeTeachingUX-div-393">

              <Input
                id="CardDischargeTeachingUX-Input-480"
                onChange={props.handleChangeValue("disc_teaching7.items.1.sub_first_user_name")}
                style={{width:"100%"}}
                value={props.ClinicalTermTeaching?.disc_teaching7?.items?.[1]?.sub_first_user_name}>
              </Input>
            </div>
            <div
              id="CardDischargeTeachingUX-div-394">

              <Dropdown
                allowAdditions={true}
                fluid={true}
                id="CardDischargeTeachingUX-Dropdown-405"
                multiple={true}
                name="knowledge"
                onAddItem={props.onAddOptions}
                onChange={props.handleChangeValue("disc_teaching7.items.1.sub_second")}
                options={props.optionstype}
                search={true}
                selection={true}
                value={props.ClinicalTermTeaching?.disc_teaching7?.items?.[1]?.sub_second}>
              </Dropdown>
            </div>
            <div
              id="CardDischargeTeachingUX-div-395">

              <Input
                id="CardDischargeTeachingUX-Input-500"
                onChange={props.handleChangeValue("disc_teaching7.items.1.sub_second_user_name")}
                style={{width:"100%"}}
                value={props.ClinicalTermTeaching?.disc_teaching7?.items?.[1]?.sub_second_user_name}>
              </Input>
            </div>
            <div
              id="CardDischargeTeachingUX-div-396">

              <Dropdown
                allowAdditions={true}
                fluid={true}
                id="CardDischargeTeachingUX-Dropdown-407"
                multiple={true}
                name="knowledge"
                onAddItem={props.onAddOptions}
                onChange={props.handleChangeValue("disc_teaching7.items.1.sub_home")}
                options={props.optionstype}
                search={true}
                selection={true}
                value={props.ClinicalTermTeaching?.disc_teaching7?.items?.[1]?.sub_home}>
              </Dropdown>
            </div>
            <div
              id="CardDischargeTeachingUX-div-397">

              <Input
                id="CardDischargeTeachingUX-Input-510"
                onChange={props.handleChangeValue("disc_teaching7.items.1.sub_home_user_name")}
                style={{width:"100%"}}
                value={props.ClinicalTermTeaching?.disc_teaching7?.items?.[1]?.sub_home_user_name}>
              </Input>
            </div>
            <div
              id="CardDischargeTeachingUX-div-409"
              style={{ gridColumn: "1/3" ,display:"flex" }}>
              {`- ${props.ClinicalTermTeaching?.disc_teaching7?.items?.[2]?.name}`}
            </div>
            <div
              id="CardDischargeTeachingUX-div-410">

              <Dropdown
                allowAdditions={true}
                fluid={true}
                id="CardDischargeTeachingUX-Dropdown-422"
                multiple={true}
                name="relative"
                onAddItem={props.onAddOptions}
                onChange={props.handleChangeValue("disc_teaching7.items.2.sub_relative")}
                options={props.options}
                search={true}
                selection={true}
                value={props.ClinicalTermTeaching?.disc_teaching7?.items?.[2]?.sub_relative}>
              </Dropdown>
            </div>
            <div
              id="CardDischargeTeachingUX-div-411">

              <Input
                id="CardDischargeTeachingUX-Input-421"
                onChange={props.handleChangeValue("disc_teaching7.items.2.sub_relative_name")}
                style={{width:"100%"}}
                value={props.ClinicalTermTeaching?.disc_teaching7?.items?.[2]?.sub_relative_name}>
              </Input>
            </div>
            <div
              id="CardDischargeTeachingUX-div-412">

              <Dropdown
                allowAdditions={true}
                fluid={true}
                id="CardDischargeTeachingUX-Dropdown-423"
                multiple={true}
                name="method"
                onAddItem={props.onAddOptions}
                onChange={props.handleChangeValue("disc_teaching7.items.2.sub_method")}
                options={props.optionsmethod}
                search={true}
                selection={true}
                value={props.ClinicalTermTeaching?.disc_teaching7?.items?.[2]?.sub_method}>
              </Dropdown>
            </div>
            <div
              id="CardDischargeTeachingUX-div-413">

              <Dropdown
                allowAdditions={true}
                fluid={true}
                id="CardDischargeTeachingUX-Dropdown-424"
                multiple={true}
                name="knowledge"
                onAddItem={props.onAddOptions}
                onChange={props.handleChangeValue("disc_teaching7.items.2.sub_before")}
                options={props.optionstype}
                search={true}
                selection={true}
                value={props.ClinicalTermTeaching?.disc_teaching7?.items?.[2]?.sub_before}>
              </Dropdown>
            </div>
            <div
              id="CardDischargeTeachingUX-div-414">

              <Input
                id="CardDischargeTeachingUX-Input-467"
                onChange={props.handleChangeValue("disc_teaching7.items.2.sub_before_user_name")}
                style={{width:"100%"}}
                value={props.ClinicalTermTeaching?.disc_teaching7?.items?.[2]?.sub_before_user_name}>
              </Input>
            </div>
            <div
              id="CardDischargeTeachingUX-div-415">

              <Dropdown
                allowAdditions={true}
                fluid={true}
                id="CardDischargeTeachingUX-Dropdown-426"
                multiple={true}
                name="knowledge"
                onAddItem={props.onAddOptions}
                onChange={props.handleChangeValue("disc_teaching7.items.2.sub_first")}
                options={props.optionstype}
                search={true}
                selection={true}
                value={props.ClinicalTermTeaching?.disc_teaching7?.items?.[2]?.sub_first}>
              </Dropdown>
            </div>
            <div
              id="CardDischargeTeachingUX-div-416">

              <Input
                id="CardDischargeTeachingUX-Input-481"
                onChange={props.handleChangeValue("disc_teaching7.items.2.sub_first_user_name")}
                style={{width:"100%"}}
                value={props.ClinicalTermTeaching?.disc_teaching7?.items?.[2]?.sub_first_user_name}>
              </Input>
            </div>
            <div
              id="CardDischargeTeachingUX-div-417">

              <Dropdown
                allowAdditions={true}
                fluid={true}
                id="CardDischargeTeachingUX-Dropdown-428"
                multiple={true}
                name="knowledge"
                onAddItem={props.onAddOptions}
                onChange={props.handleChangeValue("disc_teaching7.items.2.sub_second")}
                options={props.optionstype}
                search={true}
                selection={true}
                value={props.ClinicalTermTeaching?.disc_teaching7?.items?.[2]?.sub_second}>
              </Dropdown>
            </div>
            <div
              id="CardDischargeTeachingUX-div-418">

              <Input
                id="CardDischargeTeachingUX-Input-501"
                onChange={props.handleChangeValue("disc_teaching7.items.2.sub_second_user_name")}
                style={{width:"100%"}}
                value={props.ClinicalTermTeaching?.disc_teaching7?.items?.[2]?.sub_second_user_name}>
              </Input>
            </div>
            <div
              id="CardDischargeTeachingUX-div-419">

              <Dropdown
                allowAdditions={true}
                fluid={true}
                id="CardDischargeTeachingUX-Dropdown-430"
                multiple={true}
                name="knowledge"
                onAddItem={props.onAddOptions}
                onChange={props.handleChangeValue("disc_teaching7.items.2.sub_home")}
                options={props.optionstype}
                search={true}
                selection={true}
                value={props.ClinicalTermTeaching?.disc_teaching7?.items?.[2]?.sub_home}>
              </Dropdown>
            </div>
            <div
              id="CardDischargeTeachingUX-div-420">

              <Input
                id="CardDischargeTeachingUX-Input-511"
                onChange={props.handleChangeValue("disc_teaching7.items.2.sub_home_user_name")}
                style={{width:"100%"}}
                value={props.ClinicalTermTeaching?.disc_teaching7?.items?.[2]?.sub_home_user_name}>
              </Input>
            </div>
            <div
              id="CardDischargeTeachingUX-div-432"
              style={{ gridColumn: "1/3", fontWeight: "bold" ,display:"flex" }}>
              {`8. ${props.ClinicalTermTeaching?.disc_teaching8?.name}`}
            </div>
            <div
              id="CardDischargeTeachingUX-div-433">

              <Dropdown
                allowAdditions={true}
                fluid={true}
                id="CardDischargeTeachingUX-Dropdown-445"
                multiple={true}
                name="relative"
                onAddItem={props.onAddOptions}
                onChange={props.handleChangeValue("disc_teaching8.main_relative")}
                options={props.options}
                search={true}
                selection={true}
                value={props.ClinicalTermTeaching?.disc_teaching8?.main_relative}>
              </Dropdown>
            </div>
            <div
              id="CardDischargeTeachingUX-div-434">

              <Input
                id="CardDischargeTeachingUX-Input-444"
                onChange={props.handleChangeValue("disc_teaching8.main_relative_name")}
                style={{width:"100%"}}
                value={props.ClinicalTermTeaching?.disc_teaching8?.main_relative_name}>
              </Input>
            </div>
            <div
              id="CardDischargeTeachingUX-div-435">

              <Dropdown
                allowAdditions={true}
                fluid={true}
                id="CardDischargeTeachingUX-Dropdown-446"
                multiple={true}
                name="method"
                onAddItem={props.onAddOptions}
                onChange={props.handleChangeValue("disc_teaching8.main_method")}
                options={props.optionsmethod}
                search={true}
                selection={true}
                value={props.ClinicalTermTeaching?.disc_teaching8?.main_method}>
              </Dropdown>
            </div>
            <div
              id="CardDischargeTeachingUX-div-436">

              <Dropdown
                allowAdditions={true}
                fluid={true}
                id="CardDischargeTeachingUX-Dropdown-447"
                multiple={true}
                name="knowledge"
                onAddItem={props.onAddOptions}
                onChange={props.handleChangeValue("disc_teaching8.main_before")}
                options={props.optionstype}
                search={true}
                selection={true}
                value={props.ClinicalTermTeaching?.disc_teaching8?.main_before}>
              </Dropdown>
            </div>
            <div
              id="CardDischargeTeachingUX-div-437">

              <Input
                id="CardDischargeTeachingUX-Input-468"
                onChange={props.handleChangeValue("disc_teaching8.main_before_user_name")}
                style={{width:"100%"}}
                value={props.ClinicalTermTeaching?.disc_teaching8?.main_before_user_name}>
              </Input>
            </div>
            <div
              id="CardDischargeTeachingUX-div-438">

              <Dropdown
                allowAdditions={true}
                fluid={true}
                id="CardDischargeTeachingUX-Dropdown-449"
                multiple={true}
                name="knowledge"
                onAddItem={props.onAddOptions}
                onChange={props.handleChangeValue("disc_teaching8.main_first")}
                options={props.optionstype}
                search={true}
                selection={true}
                value={props.ClinicalTermTeaching?.disc_teaching8?.main_first}>
              </Dropdown>
            </div>
            <div
              id="CardDischargeTeachingUX-div-439">

              <Input
                id="CardDischargeTeachingUX-Input-482"
                onChange={props.handleChangeValue("disc_teaching8.main_first_user_name")}
                style={{width:"100%"}}
                value={props.ClinicalTermTeaching?.disc_teaching8?.main_first_user_name}>
              </Input>
            </div>
            <div
              id="CardDischargeTeachingUX-div-440">

              <Dropdown
                allowAdditions={true}
                fluid={true}
                id="CardDischargeTeachingUX-Dropdown-451"
                multiple={true}
                name="knowledge"
                onAddItem={props.onAddOptions}
                onChange={props.handleChangeValue("disc_teaching8.main_second")}
                options={props.optionstype}
                search={true}
                selection={true}
                value={props.ClinicalTermTeaching?.disc_teaching8?.main_second}>
              </Dropdown>
            </div>
            <div
              id="CardDischargeTeachingUX-div-441">

              <Input
                id="CardDischargeTeachingUX-Input-502"
                onChange={props.handleChangeValue("disc_teaching8.main_second_user_name")}
                style={{width:"100%"}}
                value={props.ClinicalTermTeaching?.disc_teaching8?.main_second_user_name}>
              </Input>
            </div>
            <div
              id="CardDischargeTeachingUX-div-442">

              <Dropdown
                allowAdditions={true}
                fluid={true}
                id="CardDischargeTeachingUX-Dropdown-453"
                multiple={true}
                name="knowledge"
                onAddItem={props.onAddOptions}
                onChange={props.handleChangeValue("disc_teaching8.main_home")}
                options={props.optionstype}
                search={true}
                selection={true}
                value={props.ClinicalTermTeaching?.disc_teaching8?.main_home}>
              </Dropdown>
            </div>
            <div
              id="CardDischargeTeachingUX-div-443">

              <Input
                id="CardDischargeTeachingUX-Input-512"
                onChange={props.handleChangeValue("disc_teaching8.main_home_user_name")}
                style={{width:"100%"}}
                value={props.ClinicalTermTeaching?.disc_teaching8?.main_home_user_name}>
              </Input>
            </div>
          </div>
        </div>
      </div>
    )
}


export default CardDischargeTeachingUX

export const screenPropsDefault = {"drugSearch":"[Drug Search Box]"}

/* Date Time : Mon Aug 18 2025 17:40:28 GMT+0700 (Indochina Time)
/* Original screen Data ************************************************************

{
  "elements": [
    {
      "id": 0,
      "name": "div",
      "parent": -1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-div-0"
        },
        "style": {
          "type": "code",
          "value": "{padding: \"10px\"}"
        }
      },
      "seq": 0
    },
    {
      "from": null,
      "id": 88,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-div-88"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", justifyContent: \"space-between\"}"
        }
      },
      "seq": 2,
      "void": false
    },
    {
      "from": null,
      "id": 97,
      "name": "div",
      "parent": 88,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-div-97"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", alignItems: \"center\"}"
        }
      },
      "seq": 97,
      "void": false
    },
    {
      "from": null,
      "id": 98,
      "name": "div",
      "parent": 88,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-div-98"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\"}"
        }
      },
      "seq": 98,
      "void": false
    },
    {
      "from": null,
      "id": 99,
      "name": "div",
      "parent": 97,
      "props": {
        "children": {
          "type": "value",
          "value": "การสอนการปลดประจำการ",
          "valueEN": "DISCHARGE TEACHING"
        },
        "className": {
          "type": "value",
          "value": "ui label yellow ribbon"
        },
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-div-99"
        },
        "style": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 99,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 101,
      "name": "Label",
      "parent": 98,
      "props": {
        "children": {
          "type": "value",
          "value": "ร่าง",
          "valueEN": "Draft"
        },
        "className": {
          "type": "value",
          "value": ""
        },
        "color": {
          "type": "value",
          "value": "yellow"
        },
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-Label-101"
        },
        "name": {
          "type": "value",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{display: props.showStatus ? \"\" : \"none\"}"
        }
      },
      "seq": 101,
      "void": false
    },
    {
      "from": null,
      "id": 102,
      "name": "div",
      "parent": 98,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-div-102"
        },
        "style": {
          "type": "code",
          "value": "{cursor: \"pointer\", margin: \"-5px -5px 0 15px\", display: props.closeIcon ? \"\" : \"none\"}"
        }
      },
      "seq": 102,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 103,
      "name": "Icon",
      "parent": 102,
      "props": {
        "className": {
          "type": "value",
          "value": "red large"
        },
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-Icon-103"
        },
        "name": {
          "type": "code",
          "value": "\"close\""
        },
        "onClick": {
          "type": "code",
          "value": "props.onClose"
        }
      },
      "seq": 103,
      "void": false
    },
    {
      "from": null,
      "id": 104,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-div-104"
        },
        "style": {
          "type": "code",
          "value": "{paddingTop:\"10px\"}"
        }
      },
      "seq": 104,
      "void": false
    },
    {
      "from": null,
      "id": 119,
      "name": "div",
      "parent": 104,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-div-119"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"grid\", gridTemplateColumns: \"repeat(13, minmax(0, 1fr))\", }"
        }
      },
      "seq": 119,
      "void": false
    },
    {
      "from": null,
      "id": 120,
      "name": "div",
      "parent": 119,
      "props": {
        "children": {
          "type": "value",
          "value": "ผู้ป่วยและครอบครัวได้รับการสอน /คำแนะนำ",
          "valueEN": "Patients and families receive education/advice."
        },
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-div-120"
        },
        "style": {
          "type": "code",
          "value": "{ gridColumn: \"1/3\", fontWeight: \"bold\" ,display:\"flex\" }"
        }
      },
      "seq": 120,
      "void": false
    },
    {
      "from": null,
      "id": 121,
      "name": "div",
      "parent": 119,
      "props": {
        "children": {
          "type": "value",
          "value": "ผู้รับการสอน",
          "valueEN": "Tutor"
        },
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-div-121"
        },
        "style": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 121,
      "void": false
    },
    {
      "from": null,
      "id": 122,
      "name": "div",
      "parent": 119,
      "props": {
        "children": {
          "type": "value",
          "value": "ชื่อผู้รับ",
          "valueEN": "Recipient Name"
        },
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-div-122"
        },
        "style": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 122,
      "void": false
    },
    {
      "from": null,
      "id": 123,
      "name": "div",
      "parent": 119,
      "props": {
        "children": {
          "type": "value",
          "value": "วิธีการให้ความรู้",
          "valueEN": "How to educate"
        },
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-div-123"
        },
        "style": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 123,
      "void": false
    },
    {
      "from": null,
      "id": 124,
      "name": "div",
      "parent": 119,
      "props": {
        "children": {
          "type": "value",
          "value": "ระดับความรู้ก่อนสอน",
          "valueEN": "Level of knowledge before teaching"
        },
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-div-124"
        },
        "style": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 124,
      "void": false
    },
    {
      "from": null,
      "id": 125,
      "name": "div",
      "parent": 119,
      "props": {
        "children": {
          "type": "value",
          "value": "ผู้ประเมินก่อนสอน",
          "valueEN": "Pre-Teaching Evaluator"
        },
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-div-125"
        }
      },
      "seq": 125,
      "void": false
    },
    {
      "from": null,
      "id": 126,
      "name": "div",
      "parent": 119,
      "props": {
        "children": {
          "type": "value",
          "value": "ระดับความรู้สอนครั้งที่ 1 "
        },
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-div-126"
        }
      },
      "seq": 126,
      "void": false
    },
    {
      "from": null,
      "id": 127,
      "name": "div",
      "parent": 119,
      "props": {
        "children": {
          "type": "value",
          "value": "ผู้ประเมินครั้งที่ 1 "
        },
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-div-127"
        }
      },
      "seq": 127,
      "void": false
    },
    {
      "from": null,
      "id": 128,
      "name": "div",
      "parent": 119,
      "props": {
        "children": {
          "type": "value",
          "value": "ระดับความรู้สอนครั้งที่ 2",
          "valueEN": "Second teaching knowledge level"
        },
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-div-128"
        }
      },
      "seq": 128,
      "void": false
    },
    {
      "from": null,
      "id": 129,
      "name": "div",
      "parent": 119,
      "props": {
        "children": {
          "type": "value",
          "value": "ผู้ประเมินครั้งที่ 2 "
        },
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-div-129"
        }
      },
      "seq": 129,
      "void": false
    },
    {
      "from": null,
      "id": 130,
      "name": "div",
      "parent": 119,
      "props": {
        "children": {
          "type": "value",
          "value": "ระดับความรู้สอนก่อนกลับบ้าน",
          "valueEN": "Knowledge level taught before going home"
        },
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-div-130"
        }
      },
      "seq": 130,
      "void": false
    },
    {
      "from": null,
      "id": 131,
      "name": "div",
      "parent": 119,
      "props": {
        "children": {
          "type": "value",
          "value": "ผู้ประเมินก่อนกลับบ้าน",
          "valueEN": "Pre-home assessor"
        },
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-div-131"
        }
      },
      "seq": 131,
      "void": false
    },
    {
      "from": null,
      "id": 132,
      "name": "div",
      "parent": 119,
      "props": {
        "children": {
          "type": "code",
          "value": "`1. ${props.ClinicalTermTeaching?.disc_teaching1?.name}`"
        },
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-div-132"
        },
        "style": {
          "type": "code",
          "value": "{ gridColumn: \"1/3\", fontWeight: \"bold\" ,display:\"flex\" }"
        }
      },
      "seq": 132,
      "void": false
    },
    {
      "from": null,
      "id": 133,
      "name": "div",
      "parent": 119,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-div-133"
        }
      },
      "seq": 133,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 134,
      "name": "Dropdown",
      "parent": 133,
      "props": {
        "allowAdditions": {
          "type": "code",
          "value": "true"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-Dropdown-134"
        },
        "multiple": {
          "type": "code",
          "value": "true"
        },
        "name": {
          "type": "value",
          "value": "relative"
        },
        "onAddItem": {
          "type": "code",
          "value": "props.onAddOptions"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeValue(\"disc_teaching1.main_relative\")"
        },
        "options": {
          "type": "code",
          "value": "props.options"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "value": {
          "type": "code",
          "value": "props.ClinicalTermTeaching?.disc_teaching1?.main_relative"
        }
      },
      "seq": 134,
      "void": false
    },
    {
      "from": null,
      "id": 135,
      "name": "div",
      "parent": 119,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-div-135"
        }
      },
      "seq": 135,
      "void": false
    },
    {
      "from": null,
      "id": 136,
      "name": "div",
      "parent": 119,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-div-136"
        }
      },
      "seq": 136,
      "void": false
    },
    {
      "from": null,
      "id": 137,
      "name": "div",
      "parent": 119,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-div-137"
        }
      },
      "seq": 137,
      "void": false
    },
    {
      "from": null,
      "id": 138,
      "name": "div",
      "parent": 119,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-div-138"
        }
      },
      "seq": 138,
      "void": false
    },
    {
      "from": null,
      "id": 139,
      "name": "div",
      "parent": 119,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-div-139"
        }
      },
      "seq": 139,
      "void": false
    },
    {
      "from": null,
      "id": 140,
      "name": "div",
      "parent": 119,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-div-140"
        }
      },
      "seq": 140,
      "void": false
    },
    {
      "from": null,
      "id": 141,
      "name": "div",
      "parent": 119,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-div-141"
        },
        "style": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 141,
      "void": false
    },
    {
      "from": null,
      "id": 142,
      "name": "div",
      "parent": 119,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-div-142"
        },
        "style": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 142,
      "void": false
    },
    {
      "from": null,
      "id": 143,
      "name": "div",
      "parent": 119,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-div-143"
        }
      },
      "seq": 143,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 145,
      "name": "Dropdown",
      "parent": 136,
      "props": {
        "allowAdditions": {
          "type": "code",
          "value": "true"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-Dropdown-145"
        },
        "multiple": {
          "type": "code",
          "value": "true"
        },
        "name": {
          "type": "value",
          "value": "method"
        },
        "onAddItem": {
          "type": "code",
          "value": "props.onAddOptions"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeValue(\"disc_teaching1.main_method\")"
        },
        "options": {
          "type": "code",
          "value": "props.optionsmethod"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "value": {
          "type": "code",
          "value": "props.ClinicalTermTeaching?.disc_teaching1?.main_method"
        }
      },
      "seq": 145,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 146,
      "name": "Dropdown",
      "parent": 137,
      "props": {
        "allowAdditions": {
          "type": "code",
          "value": "true"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-Dropdown-146"
        },
        "multiple": {
          "type": "code",
          "value": "true"
        },
        "name": {
          "type": "value",
          "value": "knowledge"
        },
        "onAddItem": {
          "type": "code",
          "value": "props.onAddOptions"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeValue(\"disc_teaching1.main_before\")"
        },
        "options": {
          "type": "code",
          "value": "props.optionstype"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "value": {
          "type": "code",
          "value": "props.ClinicalTermTeaching?.disc_teaching1?.main_before"
        }
      },
      "seq": 146,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 148,
      "name": "Dropdown",
      "parent": 139,
      "props": {
        "allowAdditions": {
          "type": "code",
          "value": "true"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-Dropdown-148"
        },
        "multiple": {
          "type": "code",
          "value": "true"
        },
        "name": {
          "type": "value",
          "value": "knowledge"
        },
        "onAddItem": {
          "type": "code",
          "value": "props.onAddOptions"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeValue(\"disc_teaching1.main_first\")"
        },
        "options": {
          "type": "code",
          "value": "props.optionstype"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "value": {
          "type": "code",
          "value": "props.ClinicalTermTeaching?.disc_teaching1?.main_first"
        }
      },
      "seq": 148,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 150,
      "name": "Dropdown",
      "parent": 141,
      "props": {
        "allowAdditions": {
          "type": "code",
          "value": "true"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-Dropdown-150"
        },
        "multiple": {
          "type": "code",
          "value": "true"
        },
        "name": {
          "type": "value",
          "value": "knowledge"
        },
        "onAddItem": {
          "type": "code",
          "value": "props.onAddOptions"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeValue(\"disc_teaching1.main_second\")"
        },
        "options": {
          "type": "code",
          "value": "props.optionstype"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "value": {
          "type": "code",
          "value": "props.ClinicalTermTeaching?.disc_teaching1?.main_second"
        }
      },
      "seq": 150,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 152,
      "name": "Dropdown",
      "parent": 143,
      "props": {
        "allowAdditions": {
          "type": "code",
          "value": "true"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-Dropdown-152"
        },
        "multiple": {
          "type": "code",
          "value": "true"
        },
        "name": {
          "type": "value",
          "value": "knowledge"
        },
        "onAddItem": {
          "type": "code",
          "value": "props.onAddOptions"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeValue(\"disc_teaching1.main_home\")"
        },
        "options": {
          "type": "code",
          "value": "props.optionstype"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "value": {
          "type": "code",
          "value": "props.ClinicalTermTeaching?.disc_teaching1?.main_home"
        }
      },
      "seq": 152,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 153,
      "name": "Input",
      "parent": 135,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-Input-153"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeValue(\"disc_teaching1.main_relative_name\")"
        },
        "style": {
          "type": "code",
          "value": "{width:\"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.ClinicalTermTeaching?.disc_teaching1?.main_relative_name"
        }
      },
      "seq": 153,
      "void": false
    },
    {
      "from": null,
      "id": 154,
      "name": "div",
      "parent": 119,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-div-154"
        }
      },
      "seq": 154,
      "void": false
    },
    {
      "from": null,
      "id": 156,
      "name": "div",
      "parent": 119,
      "props": {
        "children": {
          "type": "code",
          "value": "`- ${props.ClinicalTermTeaching?.disc_teaching1?.items?.[0]?.name}`"
        },
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-div-156"
        },
        "style": {
          "type": "code",
          "value": "{ gridColumn: \"1/3\" ,display:\"flex\" }"
        }
      },
      "seq": 156,
      "void": false
    },
    {
      "from": null,
      "id": 157,
      "name": "div",
      "parent": 119,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-div-157"
        }
      },
      "seq": 157,
      "void": false
    },
    {
      "from": null,
      "id": 158,
      "name": "div",
      "parent": 119,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-div-158"
        }
      },
      "seq": 158,
      "void": false
    },
    {
      "from": null,
      "id": 159,
      "name": "div",
      "parent": 119,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-div-159"
        }
      },
      "seq": 159,
      "void": false
    },
    {
      "from": null,
      "id": 160,
      "name": "div",
      "parent": 119,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-div-160"
        }
      },
      "seq": 160,
      "void": false
    },
    {
      "from": null,
      "id": 161,
      "name": "div",
      "parent": 119,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-div-161"
        }
      },
      "seq": 161,
      "void": false
    },
    {
      "from": null,
      "id": 162,
      "name": "div",
      "parent": 119,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-div-162"
        }
      },
      "seq": 162,
      "void": false
    },
    {
      "from": null,
      "id": 163,
      "name": "div",
      "parent": 119,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-div-163"
        }
      },
      "seq": 163,
      "void": false
    },
    {
      "from": null,
      "id": 164,
      "name": "div",
      "parent": 119,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-div-164"
        }
      },
      "seq": 164,
      "void": false
    },
    {
      "from": null,
      "id": 165,
      "name": "div",
      "parent": 119,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-div-165"
        }
      },
      "seq": 165,
      "void": false
    },
    {
      "from": null,
      "id": 166,
      "name": "div",
      "parent": 119,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-div-166"
        }
      },
      "seq": 166,
      "void": false
    },
    {
      "from": null,
      "id": 167,
      "name": "div",
      "parent": 119,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-div-167"
        }
      },
      "seq": 167,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 168,
      "name": "Input",
      "parent": 158,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-Input-168"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeValue(\"disc_teaching1.items.0.sub_relative_name\")"
        },
        "style": {
          "type": "code",
          "value": "{width:\"100%\" }"
        },
        "value": {
          "type": "code",
          "value": "props.ClinicalTermTeaching?.disc_teaching1?.items?.[0]?.sub_relative_name"
        }
      },
      "seq": 168,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 169,
      "name": "Dropdown",
      "parent": 157,
      "props": {
        "allowAdditions": {
          "type": "code",
          "value": "true"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-Dropdown-169"
        },
        "multiple": {
          "type": "code",
          "value": "true"
        },
        "name": {
          "type": "value",
          "value": "relative"
        },
        "onAddItem": {
          "type": "code",
          "value": "props.onAddOptions"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeValue(\"disc_teaching1.items.0.sub_relative\")"
        },
        "options": {
          "type": "code",
          "value": "props.options"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "value": {
          "type": "code",
          "value": "props.ClinicalTermTeaching?.disc_teaching1?.items?.[0]?.sub_relative"
        }
      },
      "seq": 169,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 170,
      "name": "Dropdown",
      "parent": 159,
      "props": {
        "allowAdditions": {
          "type": "code",
          "value": "true"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-Dropdown-170"
        },
        "multiple": {
          "type": "code",
          "value": "true"
        },
        "name": {
          "type": "value",
          "value": "method"
        },
        "onAddItem": {
          "type": "code",
          "value": "props.onAddOptions"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeValue(\"disc_teaching1.items.0.sub_method\")"
        },
        "options": {
          "type": "code",
          "value": "props.optionsmethod"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "value": {
          "type": "code",
          "value": "props.ClinicalTermTeaching?.disc_teaching1?.items?.[0]?.sub_method"
        }
      },
      "seq": 170,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 171,
      "name": "Dropdown",
      "parent": 160,
      "props": {
        "allowAdditions": {
          "type": "code",
          "value": "true"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-Dropdown-171"
        },
        "multiple": {
          "type": "code",
          "value": "true"
        },
        "name": {
          "type": "value",
          "value": "knowledge"
        },
        "onAddItem": {
          "type": "code",
          "value": ""
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeValue(\"disc_teaching1.items.0.sub_before\")"
        },
        "options": {
          "type": "code",
          "value": "props.optionstype"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "value": {
          "type": "code",
          "value": "props.ClinicalTermTeaching?.disc_teaching1?.items?.[0]?.sub_before"
        }
      },
      "seq": 171,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 173,
      "name": "Dropdown",
      "parent": 162,
      "props": {
        "allowAdditions": {
          "type": "code",
          "value": "true"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-Dropdown-173"
        },
        "multiple": {
          "type": "code",
          "value": "true"
        },
        "name": {
          "type": "value",
          "value": "knowledge"
        },
        "onAddItem": {
          "type": "code",
          "value": "props.onAddOptions"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeValue(\"disc_teaching1.items.0.sub_first\")"
        },
        "options": {
          "type": "code",
          "value": "props.optionstype"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "value": {
          "type": "code",
          "value": "props.ClinicalTermTeaching?.disc_teaching1?.items?.[0]?.sub_first"
        }
      },
      "seq": 173,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 175,
      "name": "Dropdown",
      "parent": 164,
      "props": {
        "allowAdditions": {
          "type": "code",
          "value": "true"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-Dropdown-175"
        },
        "multiple": {
          "type": "code",
          "value": "true"
        },
        "name": {
          "type": "value",
          "value": "knowledge"
        },
        "onAddItem": {
          "type": "code",
          "value": "props.onAddOptions"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeValue(\"disc_teaching1.items.0.sub_second\")"
        },
        "options": {
          "type": "code",
          "value": "props.optionstype"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "value": {
          "type": "code",
          "value": "props.ClinicalTermTeaching?.disc_teaching1?.items?.[0]?.sub_second"
        }
      },
      "seq": 175,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 177,
      "name": "Dropdown",
      "parent": 166,
      "props": {
        "allowAdditions": {
          "type": "code",
          "value": "true"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-Dropdown-177"
        },
        "multiple": {
          "type": "code",
          "value": "true"
        },
        "name": {
          "type": "value",
          "value": "knowledge"
        },
        "onAddItem": {
          "type": "code",
          "value": "props.onAddOptions"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeValue(\"disc_teaching1.items.0.sub_home\")"
        },
        "options": {
          "type": "code",
          "value": "props.optionstype"
        },
        "search": {
          "type": "code",
          "value": ""
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "value": {
          "type": "code",
          "value": "props.ClinicalTermTeaching?.disc_teaching1?.items?.[0]?.sub_home"
        }
      },
      "seq": 177,
      "void": false
    },
    {
      "from": null,
      "id": 179,
      "name": "div",
      "parent": 119,
      "props": {
        "children": {
          "type": "code",
          "value": "`- ${props.ClinicalTermTeaching?.disc_teaching1?.items?.[1]?.name}`"
        },
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-div-179"
        },
        "style": {
          "type": "code",
          "value": "{ gridColumn: \"1/3\" ,display:\"flex\" }"
        }
      },
      "seq": 179,
      "void": false
    },
    {
      "from": null,
      "id": 180,
      "name": "div",
      "parent": 119,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-div-180"
        }
      },
      "seq": 180,
      "void": false
    },
    {
      "from": null,
      "id": 181,
      "name": "div",
      "parent": 119,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-div-181"
        }
      },
      "seq": 181,
      "void": false
    },
    {
      "from": null,
      "id": 182,
      "name": "div",
      "parent": 119,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-div-182"
        }
      },
      "seq": 182,
      "void": false
    },
    {
      "from": null,
      "id": 183,
      "name": "div",
      "parent": 119,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-div-183"
        }
      },
      "seq": 183,
      "void": false
    },
    {
      "from": null,
      "id": 184,
      "name": "div",
      "parent": 119,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-div-184"
        }
      },
      "seq": 184,
      "void": false
    },
    {
      "from": null,
      "id": 185,
      "name": "div",
      "parent": 119,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-div-185"
        }
      },
      "seq": 185,
      "void": false
    },
    {
      "from": null,
      "id": 186,
      "name": "div",
      "parent": 119,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-div-186"
        }
      },
      "seq": 186,
      "void": false
    },
    {
      "from": null,
      "id": 187,
      "name": "div",
      "parent": 119,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-div-187"
        }
      },
      "seq": 187,
      "void": false
    },
    {
      "from": null,
      "id": 188,
      "name": "div",
      "parent": 119,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-div-188"
        }
      },
      "seq": 188,
      "void": false
    },
    {
      "from": null,
      "id": 189,
      "name": "div",
      "parent": 119,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-div-189"
        }
      },
      "seq": 189,
      "void": false
    },
    {
      "from": null,
      "id": 190,
      "name": "div",
      "parent": 119,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-div-190"
        }
      },
      "seq": 190,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 191,
      "name": "Input",
      "parent": 181,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-Input-191"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeValue(\"disc_teaching1.items.1.sub_relative_name\")"
        },
        "style": {
          "type": "code",
          "value": "{width:\"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.ClinicalTermTeaching?.disc_teaching1?.items?.[1]?.sub_relative_name"
        }
      },
      "seq": 191,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 192,
      "name": "Dropdown",
      "parent": 180,
      "props": {
        "allowAdditions": {
          "type": "code",
          "value": "true"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-Dropdown-192"
        },
        "multiple": {
          "type": "code",
          "value": "true"
        },
        "name": {
          "type": "value",
          "value": "relative"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeValue(\"disc_teaching1.items.1.sub_relative\")"
        },
        "options": {
          "type": "code",
          "value": "props.options"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "value": {
          "type": "code",
          "value": "props.ClinicalTermTeaching?.disc_teaching1?.items?.[1]?.sub_relative"
        }
      },
      "seq": 192,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 193,
      "name": "Dropdown",
      "parent": 182,
      "props": {
        "allowAdditions": {
          "type": "code",
          "value": "true"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-Dropdown-193"
        },
        "multiple": {
          "type": "code",
          "value": "true"
        },
        "name": {
          "type": "value",
          "value": "method"
        },
        "onAddItem": {
          "type": "code",
          "value": "props.onAddOptions"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeValue(\"disc_teaching1.items.1.sub_method\")"
        },
        "options": {
          "type": "code",
          "value": "props.optionsmethod"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "value": {
          "type": "code",
          "value": "props.ClinicalTermTeaching?.disc_teaching1?.items?.[1]?.sub_method"
        }
      },
      "seq": 193,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 194,
      "name": "Dropdown",
      "parent": 183,
      "props": {
        "allowAdditions": {
          "type": "code",
          "value": "true"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-Dropdown-194"
        },
        "multiple": {
          "type": "code",
          "value": "true"
        },
        "name": {
          "type": "value",
          "value": "knowledge"
        },
        "onAddItem": {
          "type": "code",
          "value": "props.onAddOptions"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeValue(\"disc_teaching1.items.1.sub_before\")"
        },
        "options": {
          "type": "code",
          "value": "props.optionstype"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "value": {
          "type": "code",
          "value": "props.ClinicalTermTeaching?.disc_teaching1?.items?.[1]?.sub_before"
        }
      },
      "seq": 194,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 196,
      "name": "Dropdown",
      "parent": 185,
      "props": {
        "allowAdditions": {
          "type": "code",
          "value": "true"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-Dropdown-196"
        },
        "multiple": {
          "type": "code",
          "value": "true"
        },
        "name": {
          "type": "value",
          "value": "knowledge"
        },
        "onAddItem": {
          "type": "code",
          "value": "props.onAddOptions"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeValue(\"disc_teaching1.items.1.sub_first\")"
        },
        "options": {
          "type": "code",
          "value": "props.optionstype"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "value": {
          "type": "code",
          "value": "props.ClinicalTermTeaching?.disc_teaching1?.items?.[1]?.sub_first"
        }
      },
      "seq": 196,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 198,
      "name": "Dropdown",
      "parent": 187,
      "props": {
        "allowAdditions": {
          "type": "code",
          "value": "true"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-Dropdown-198"
        },
        "multiple": {
          "type": "code",
          "value": "true"
        },
        "name": {
          "type": "value",
          "value": "knowledge"
        },
        "onAddItem": {
          "type": "code",
          "value": "props.onAddOptions"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeValue(\"disc_teaching1.items.1.sub_second\")"
        },
        "options": {
          "type": "code",
          "value": "props.optionstype"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "value": {
          "type": "code",
          "value": "props.ClinicalTermTeaching?.disc_teaching1?.items?.[1]?.sub_second"
        }
      },
      "seq": 198,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 200,
      "name": "Dropdown",
      "parent": 189,
      "props": {
        "allowAdditions": {
          "type": "code",
          "value": "true"
        },
        "fluid": {
          "type": "code",
          "value": "true",
          "valueEN": ""
        },
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-Dropdown-200"
        },
        "multiple": {
          "type": "code",
          "value": "true"
        },
        "name": {
          "type": "value",
          "value": "knowledge"
        },
        "onAddItem": {
          "type": "code",
          "value": "props.onAddOptions"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeValue(\"disc_teaching1.items.1.sub_home\")"
        },
        "options": {
          "type": "code",
          "value": "props.optionstype"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "value": {
          "type": "code",
          "value": "props.ClinicalTermTeaching?.disc_teaching1?.items?.[1]?.sub_home"
        }
      },
      "seq": 200,
      "void": false
    },
    {
      "from": null,
      "id": 202,
      "name": "div",
      "parent": 119,
      "props": {
        "children": {
          "type": "code",
          "value": "`- ${props.ClinicalTermTeaching?.disc_teaching1?.items?.[2]?.name}`"
        },
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-div-202"
        },
        "style": {
          "type": "code",
          "value": "{ gridColumn: \"1/3\" ,display:\"flex\" }"
        }
      },
      "seq": 202,
      "void": false
    },
    {
      "from": null,
      "id": 203,
      "name": "div",
      "parent": 119,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-div-203"
        }
      },
      "seq": 203,
      "void": false
    },
    {
      "from": null,
      "id": 204,
      "name": "div",
      "parent": 119,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-div-204"
        }
      },
      "seq": 204,
      "void": false
    },
    {
      "from": null,
      "id": 205,
      "name": "div",
      "parent": 119,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-div-205"
        }
      },
      "seq": 205,
      "void": false
    },
    {
      "from": null,
      "id": 206,
      "name": "div",
      "parent": 119,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-div-206"
        }
      },
      "seq": 206,
      "void": false
    },
    {
      "from": null,
      "id": 207,
      "name": "div",
      "parent": 119,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-div-207"
        }
      },
      "seq": 207,
      "void": false
    },
    {
      "from": null,
      "id": 208,
      "name": "div",
      "parent": 119,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-div-208"
        },
        "style": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 208,
      "void": false
    },
    {
      "from": null,
      "id": 209,
      "name": "div",
      "parent": 119,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-div-209"
        }
      },
      "seq": 209,
      "void": false
    },
    {
      "from": null,
      "id": 210,
      "name": "div",
      "parent": 119,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-div-210"
        }
      },
      "seq": 210,
      "void": false
    },
    {
      "from": null,
      "id": 211,
      "name": "div",
      "parent": 119,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-div-211"
        },
        "style": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 211,
      "void": false
    },
    {
      "from": null,
      "id": 212,
      "name": "div",
      "parent": 119,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-div-212"
        },
        "style": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 212,
      "void": false
    },
    {
      "from": null,
      "id": 213,
      "name": "div",
      "parent": 119,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-div-213"
        },
        "style": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 213,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 214,
      "name": "Input",
      "parent": 204,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-Input-214"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeValue(\"disc_teaching1.items.2.sub_relative_name\")"
        },
        "style": {
          "type": "code",
          "value": "{width:\"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.ClinicalTermTeaching?.disc_teaching1?.items?.[2]?.sub_relative_name"
        }
      },
      "seq": 214,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 215,
      "name": "Dropdown",
      "parent": 203,
      "props": {
        "allowAdditions": {
          "type": "code",
          "value": "true"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-Dropdown-215"
        },
        "multiple": {
          "type": "code",
          "value": "true"
        },
        "name": {
          "type": "value",
          "value": "relative"
        },
        "onAddItem": {
          "type": "code",
          "value": "props.onAddOptions"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeValue(\"disc_teaching1.items.2.sub_relative\")"
        },
        "options": {
          "type": "code",
          "value": "props.options"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "value": {
          "type": "code",
          "value": "props.ClinicalTermTeaching?.disc_teaching1?.items?.[2]?.sub_relative"
        }
      },
      "seq": 215,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 216,
      "name": "Dropdown",
      "parent": 205,
      "props": {
        "allowAdditions": {
          "type": "code",
          "value": "true"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-Dropdown-216"
        },
        "multiple": {
          "type": "code",
          "value": "true"
        },
        "name": {
          "type": "value",
          "value": "method"
        },
        "onAddItem": {
          "type": "code",
          "value": "props.onAddOptions"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeValue(\"disc_teaching1.items.2.sub_method\")"
        },
        "options": {
          "type": "code",
          "value": "props.optionsmethod"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "value": {
          "type": "code",
          "value": "props.ClinicalTermTeaching?.disc_teaching1?.items?.[2]?.sub_method"
        }
      },
      "seq": 216,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 217,
      "name": "Dropdown",
      "parent": 206,
      "props": {
        "allowAdditions": {
          "type": "code",
          "value": "true"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-Dropdown-217"
        },
        "multiple": {
          "type": "code",
          "value": "true"
        },
        "name": {
          "type": "value",
          "value": "knowledge"
        },
        "onAddItem": {
          "type": "code",
          "value": "props.onAddOptions"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeValue(\"disc_teaching1.items.2.sub_before\")"
        },
        "options": {
          "type": "code",
          "value": "props.optionstype"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "value": {
          "type": "code",
          "value": "props.ClinicalTermTeaching?.disc_teaching1?.items?.[2]?.sub_before"
        }
      },
      "seq": 217,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 219,
      "name": "Dropdown",
      "parent": 208,
      "props": {
        "allowAdditions": {
          "type": "code",
          "value": "true"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-Dropdown-219"
        },
        "multiple": {
          "type": "code",
          "value": "true"
        },
        "name": {
          "type": "value",
          "value": "knowledge"
        },
        "onAddItem": {
          "type": "code",
          "value": "props.onAddOptions"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeValue(\"disc_teaching1.items.2.sub_first\")"
        },
        "options": {
          "type": "code",
          "value": "props.optionstype"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "value": {
          "type": "code",
          "value": "props.ClinicalTermTeaching?.disc_teaching1?.items?.[2]?.sub_first"
        }
      },
      "seq": 219,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 221,
      "name": "Dropdown",
      "parent": 210,
      "props": {
        "allowAdditions": {
          "type": "code",
          "value": "true"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-Dropdown-221"
        },
        "multiple": {
          "type": "code",
          "value": "true"
        },
        "name": {
          "type": "value",
          "value": "knowledge"
        },
        "onAddItem": {
          "type": "code",
          "value": "props.onAddOptions"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeValue(\"disc_teaching1.items.2.sub_second\")"
        },
        "options": {
          "type": "code",
          "value": "props.optionstype"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "value": {
          "type": "code",
          "value": "props.ClinicalTermTeaching?.disc_teaching1?.items?.[2]?.sub_second"
        }
      },
      "seq": 221,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 223,
      "name": "Dropdown",
      "parent": 212,
      "props": {
        "defaultValue": {
          "type": "code",
          "value": "true"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-Dropdown-223"
        },
        "multiple": {
          "type": "code",
          "value": "true"
        },
        "name": {
          "type": "value",
          "value": "knowledge"
        },
        "onAddItem": {
          "type": "code",
          "value": "props.onAddOptions"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeValue(\"disc_teaching1.items.2.sub_home\")"
        },
        "options": {
          "type": "code",
          "value": "props.optionstype"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "value": {
          "type": "code",
          "value": "props.ClinicalTermTeaching?.disc_teaching1?.items?.[2]?.sub_home"
        }
      },
      "seq": 223,
      "void": false
    },
    {
      "from": null,
      "id": 225,
      "name": "div",
      "parent": 119,
      "props": {
        "children": {
          "type": "code",
          "value": "`2. ${props.ClinicalTermTeaching?.disc_teaching2?.name}`"
        },
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-div-225"
        },
        "style": {
          "type": "code",
          "value": "{ gridColumn: \"1/3\", fontWeight: \"bold\" ,display:\"flex\" }"
        }
      },
      "seq": 225,
      "void": false
    },
    {
      "from": null,
      "id": 226,
      "name": "div",
      "parent": 119,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-div-226"
        }
      },
      "seq": 226,
      "void": false
    },
    {
      "from": null,
      "id": 227,
      "name": "div",
      "parent": 119,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-div-227"
        }
      },
      "seq": 227,
      "void": false
    },
    {
      "from": null,
      "id": 228,
      "name": "div",
      "parent": 119,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-div-228"
        }
      },
      "seq": 228,
      "void": false
    },
    {
      "from": null,
      "id": 229,
      "name": "div",
      "parent": 119,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-div-229"
        }
      },
      "seq": 229,
      "void": false
    },
    {
      "from": null,
      "id": 230,
      "name": "div",
      "parent": 119,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-div-230"
        }
      },
      "seq": 230,
      "void": false
    },
    {
      "from": null,
      "id": 231,
      "name": "div",
      "parent": 119,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-div-231"
        },
        "style": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 231,
      "void": false
    },
    {
      "from": null,
      "id": 232,
      "name": "div",
      "parent": 119,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-div-232"
        }
      },
      "seq": 232,
      "void": false
    },
    {
      "from": null,
      "id": 233,
      "name": "div",
      "parent": 119,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-div-233"
        },
        "style": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 233,
      "void": false
    },
    {
      "from": null,
      "id": 234,
      "name": "div",
      "parent": 119,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-div-234"
        }
      },
      "seq": 234,
      "void": false
    },
    {
      "from": null,
      "id": 235,
      "name": "div",
      "parent": 119,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-div-235"
        }
      },
      "seq": 235,
      "void": false
    },
    {
      "from": null,
      "id": 236,
      "name": "div",
      "parent": 119,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-div-236"
        }
      },
      "seq": 236,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 237,
      "name": "Input",
      "parent": 227,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-Input-237"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeValue(\"disc_teaching2.main_relative_name\")"
        },
        "style": {
          "type": "code",
          "value": "{width:\"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.ClinicalTermTeaching?.disc_teaching2?.main_relative_name"
        }
      },
      "seq": 237,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 238,
      "name": "Dropdown",
      "parent": 226,
      "props": {
        "allowAdditions": {
          "type": "code",
          "value": "true"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-Dropdown-238"
        },
        "multiple": {
          "type": "code",
          "value": "true"
        },
        "name": {
          "type": "value",
          "value": "relative"
        },
        "onAddItem": {
          "type": "code",
          "value": "props.onAddOptions"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeValue(\"disc_teaching2.main_relative\")"
        },
        "options": {
          "type": "code",
          "value": "props.options"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "value": {
          "type": "code",
          "value": "props.ClinicalTermTeaching?.disc_teaching2?.main_relative"
        }
      },
      "seq": 238,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 239,
      "name": "Dropdown",
      "parent": 228,
      "props": {
        "allowAdditions": {
          "type": "code",
          "value": "true"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-Dropdown-239"
        },
        "multiple": {
          "type": "code",
          "value": "true"
        },
        "name": {
          "type": "value",
          "value": "method"
        },
        "onAddItem": {
          "type": "code",
          "value": "props.onAddOptions"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeValue(\"disc_teaching2.main_method\")"
        },
        "options": {
          "type": "code",
          "value": "props.optionsmethod"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "value": {
          "type": "code",
          "value": "props.ClinicalTermTeaching?.disc_teaching2?.main_method"
        }
      },
      "seq": 239,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 240,
      "name": "Dropdown",
      "parent": 229,
      "props": {
        "allowAdditions": {
          "type": "code",
          "value": "true"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-Dropdown-240"
        },
        "multiple": {
          "type": "code",
          "value": "true"
        },
        "name": {
          "type": "value",
          "value": "knowledge"
        },
        "onAddItem": {
          "type": "code",
          "value": "props.onAddOptions"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeValue(\"disc_teaching2.main_before\")"
        },
        "options": {
          "type": "code",
          "value": "props.optionstype"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "value": {
          "type": "code",
          "value": "props.ClinicalTermTeaching?.disc_teaching2?.main_before"
        }
      },
      "seq": 240,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 242,
      "name": "Dropdown",
      "parent": 231,
      "props": {
        "allowAdditions": {
          "type": "code",
          "value": "true"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-Dropdown-242"
        },
        "multiple": {
          "type": "code",
          "value": "true"
        },
        "name": {
          "type": "value",
          "value": "knowledge"
        },
        "onAddItem": {
          "type": "code",
          "value": "props.onAddOptions"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeValue(\"disc_teaching2.main_first\")"
        },
        "options": {
          "type": "code",
          "value": "props.optionstype"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "value": {
          "type": "code",
          "value": "props.ClinicalTermTeaching?.disc_teaching2?.main_first"
        }
      },
      "seq": 242,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 244,
      "name": "Dropdown",
      "parent": 233,
      "props": {
        "allowAdditions": {
          "type": "code",
          "value": "true"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-Dropdown-244"
        },
        "multiple": {
          "type": "code",
          "value": "true"
        },
        "name": {
          "type": "value",
          "value": "knowledge"
        },
        "onAddItem": {
          "type": "code",
          "value": "props.onAddOptions"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeValue(\"disc_teaching2.main_second\")"
        },
        "options": {
          "type": "code",
          "value": "props.optionstype"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "value": {
          "type": "code",
          "value": "props.ClinicalTermTeaching?.disc_teaching2?.main_second"
        }
      },
      "seq": 244,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 246,
      "name": "Dropdown",
      "parent": 235,
      "props": {
        "allowAdditions": {
          "type": "code",
          "value": "true"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-Dropdown-246"
        },
        "multiple": {
          "type": "code",
          "value": "true"
        },
        "name": {
          "type": "value",
          "value": "knowledge"
        },
        "onAddItem": {
          "type": "code",
          "value": "props.onAddOptions"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeValue(\"disc_teaching2.main_home\")"
        },
        "options": {
          "type": "code",
          "value": "props.optionstype"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "value": {
          "type": "code",
          "value": "props.ClinicalTermTeaching?.disc_teaching2?.main_home"
        }
      },
      "seq": 246,
      "void": false
    },
    {
      "from": null,
      "id": 248,
      "name": "div",
      "parent": 119,
      "props": {
        "children": {
          "type": "code",
          "value": "`3. ${props.ClinicalTermTeaching?.disc_teaching3?.name}`"
        },
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-div-248"
        },
        "style": {
          "type": "code",
          "value": "{ gridColumn: \"1/3\", fontWeight: \"bold\" ,display:\"flex\" }"
        }
      },
      "seq": 248,
      "void": false
    },
    {
      "from": null,
      "id": 249,
      "name": "div",
      "parent": 119,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-div-249"
        }
      },
      "seq": 249,
      "void": false
    },
    {
      "from": null,
      "id": 250,
      "name": "div",
      "parent": 119,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-div-250"
        }
      },
      "seq": 250,
      "void": false
    },
    {
      "from": null,
      "id": 251,
      "name": "div",
      "parent": 119,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-div-251"
        }
      },
      "seq": 251,
      "void": false
    },
    {
      "from": null,
      "id": 252,
      "name": "div",
      "parent": 119,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-div-252"
        }
      },
      "seq": 252,
      "void": false
    },
    {
      "from": null,
      "id": 253,
      "name": "div",
      "parent": 119,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-div-253"
        }
      },
      "seq": 253,
      "void": false
    },
    {
      "from": null,
      "id": 254,
      "name": "div",
      "parent": 119,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-div-254"
        }
      },
      "seq": 254,
      "void": false
    },
    {
      "from": null,
      "id": 255,
      "name": "div",
      "parent": 119,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-div-255"
        }
      },
      "seq": 255,
      "void": false
    },
    {
      "from": null,
      "id": 256,
      "name": "div",
      "parent": 119,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-div-256"
        }
      },
      "seq": 256,
      "void": false
    },
    {
      "from": null,
      "id": 257,
      "name": "div",
      "parent": 119,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-div-257"
        }
      },
      "seq": 257,
      "void": false
    },
    {
      "from": null,
      "id": 258,
      "name": "div",
      "parent": 119,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-div-258"
        },
        "style": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 258,
      "void": false
    },
    {
      "from": null,
      "id": 259,
      "name": "div",
      "parent": 119,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-div-259"
        }
      },
      "seq": 259,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 260,
      "name": "Input",
      "parent": 250,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-Input-260"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeValue(\"disc_teaching3.main_relative_name\")"
        },
        "style": {
          "type": "code",
          "value": "{width:\"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.ClinicalTermTeaching?.disc_teaching3?.main_relative_name"
        }
      },
      "seq": 260,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 261,
      "name": "Dropdown",
      "parent": 249,
      "props": {
        "allowAdditions": {
          "type": "code",
          "value": "true"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-Dropdown-261"
        },
        "multiple": {
          "type": "code",
          "value": "true"
        },
        "name": {
          "type": "value",
          "value": "relative"
        },
        "onAddItem": {
          "type": "code",
          "value": "props.onAddOptions"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeValue(\"disc_teaching3.main_relative\")"
        },
        "options": {
          "type": "code",
          "value": "props.options"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "value": {
          "type": "code",
          "value": "props.ClinicalTermTeaching?.disc_teaching3?.main_relative"
        }
      },
      "seq": 261,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 262,
      "name": "Dropdown",
      "parent": 251,
      "props": {
        "allowAdditions": {
          "type": "code",
          "value": "true"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-Dropdown-262"
        },
        "multiple": {
          "type": "code",
          "value": "true"
        },
        "name": {
          "type": "value",
          "value": "method"
        },
        "onAddItem": {
          "type": "code",
          "value": "props.onAddOptions"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeValue(\"disc_teaching3.main_method\")"
        },
        "options": {
          "type": "code",
          "value": "props.optionsmethod"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "value": {
          "type": "code",
          "value": "props.ClinicalTermTeaching?.disc_teaching3?.main_method"
        }
      },
      "seq": 262,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 263,
      "name": "Dropdown",
      "parent": 252,
      "props": {
        "allowAdditions": {
          "type": "code",
          "value": "true"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-Dropdown-263"
        },
        "multiple": {
          "type": "code",
          "value": "true"
        },
        "name": {
          "type": "value",
          "value": "knowledge"
        },
        "onAddItem": {
          "type": "code",
          "value": "props.onAddOptions"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeValue(\"disc_teaching3.main_before\")"
        },
        "options": {
          "type": "code",
          "value": "props.optionstype"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "value": {
          "type": "code",
          "value": "props.ClinicalTermTeaching?.disc_teaching3?.main_before"
        }
      },
      "seq": 263,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 265,
      "name": "Dropdown",
      "parent": 254,
      "props": {
        "allowAdditions": {
          "type": "code",
          "value": "true"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-Dropdown-265"
        },
        "multiple": {
          "type": "code",
          "value": "true"
        },
        "name": {
          "type": "value",
          "value": "knowledge"
        },
        "onAddItem": {
          "type": "code",
          "value": "props.onAddOptions"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeValue(\"disc_teaching3.main_first\")"
        },
        "options": {
          "type": "code",
          "value": "props.optionstype"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "value": {
          "type": "code",
          "value": "props.ClinicalTermTeaching?.disc_teaching3?.main_first"
        }
      },
      "seq": 265,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 267,
      "name": "Dropdown",
      "parent": 256,
      "props": {
        "allowAdditions": {
          "type": "code",
          "value": "true"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-Dropdown-267"
        },
        "multiple": {
          "type": "code",
          "value": "true"
        },
        "name": {
          "type": "value",
          "value": "knowledge"
        },
        "onAddItem": {
          "type": "code",
          "value": "props.onAddOptions"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeValue(\"disc_teaching3.main_second\")"
        },
        "options": {
          "type": "code",
          "value": "props.optionstype"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "value": {
          "type": "code",
          "value": "props.ClinicalTermTeaching?.disc_teaching3?.main_second"
        }
      },
      "seq": 267,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 269,
      "name": "Dropdown",
      "parent": 258,
      "props": {
        "allowAdditions": {
          "type": "code",
          "value": "true"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-Dropdown-269"
        },
        "multiple": {
          "type": "code",
          "value": "true"
        },
        "name": {
          "type": "value",
          "value": "knowledge"
        },
        "onAddItem": {
          "type": "code",
          "value": "props.onAddOptions"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeValue(\"disc_teaching3.main_home\")"
        },
        "options": {
          "type": "code",
          "value": "props.optionstype"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "value": {
          "type": "code",
          "value": "props.ClinicalTermTeaching?.disc_teaching3?.main_home"
        }
      },
      "seq": 269,
      "void": false
    },
    {
      "from": null,
      "id": 271,
      "name": "div",
      "parent": 119,
      "props": {
        "children": {
          "type": "code",
          "value": "`4. ${props.ClinicalTermTeaching?.disc_teaching4?.name}`"
        },
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-div-271"
        },
        "style": {
          "type": "code",
          "value": "{ gridColumn: \"1/3\", fontWeight: \"bold\" ,display:\"flex\" }"
        }
      },
      "seq": 271,
      "void": false
    },
    {
      "from": null,
      "id": 272,
      "name": "div",
      "parent": 119,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-div-272"
        }
      },
      "seq": 272,
      "void": false
    },
    {
      "from": null,
      "id": 273,
      "name": "div",
      "parent": 119,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-div-273"
        }
      },
      "seq": 273,
      "void": false
    },
    {
      "from": null,
      "id": 274,
      "name": "div",
      "parent": 119,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-div-274"
        }
      },
      "seq": 274,
      "void": false
    },
    {
      "from": null,
      "id": 275,
      "name": "div",
      "parent": 119,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-div-275"
        }
      },
      "seq": 275,
      "void": false
    },
    {
      "from": null,
      "id": 276,
      "name": "div",
      "parent": 119,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-div-276"
        }
      },
      "seq": 276,
      "void": false
    },
    {
      "from": null,
      "id": 277,
      "name": "div",
      "parent": 119,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-div-277"
        }
      },
      "seq": 278,
      "void": false
    },
    {
      "from": null,
      "id": 278,
      "name": "div",
      "parent": 119,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-div-278"
        }
      },
      "seq": 277,
      "void": false
    },
    {
      "from": null,
      "id": 279,
      "name": "div",
      "parent": 119,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-div-279"
        }
      },
      "seq": 279,
      "void": false
    },
    {
      "from": null,
      "id": 280,
      "name": "div",
      "parent": 119,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-div-280"
        }
      },
      "seq": 280,
      "void": false
    },
    {
      "from": null,
      "id": 281,
      "name": "div",
      "parent": 119,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-div-281"
        }
      },
      "seq": 281,
      "void": false
    },
    {
      "from": null,
      "id": 282,
      "name": "div",
      "parent": 119,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-div-282"
        }
      },
      "seq": 282,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 283,
      "name": "Input",
      "parent": 273,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-Input-283"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeValue(\"disc_teaching4.main_relative_name\")"
        },
        "style": {
          "type": "code",
          "value": "{width:\"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.ClinicalTermTeaching?.disc_teaching4?.main_relative_name"
        }
      },
      "seq": 283,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 284,
      "name": "Dropdown",
      "parent": 272,
      "props": {
        "allowAdditions": {
          "type": "code",
          "value": "true"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-Dropdown-284"
        },
        "multiple": {
          "type": "code",
          "value": "true"
        },
        "name": {
          "type": "value",
          "value": "relative"
        },
        "onAddItem": {
          "type": "code",
          "value": "props.onAddOptions"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeValue(\"disc_teaching4.main_relative\")"
        },
        "options": {
          "type": "code",
          "value": "props.options"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "value": {
          "type": "code",
          "value": "props.ClinicalTermTeaching?.disc_teaching4?.main_relative"
        }
      },
      "seq": 284,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 285,
      "name": "Dropdown",
      "parent": 274,
      "props": {
        "allowAdditions": {
          "type": "code",
          "value": "true"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-Dropdown-285"
        },
        "multiple": {
          "type": "code",
          "value": "true"
        },
        "name": {
          "type": "value",
          "value": "method"
        },
        "onAddItem": {
          "type": "code",
          "value": "props.onAddOptions"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeValue(\"disc_teaching4.main_method\")"
        },
        "options": {
          "type": "code",
          "value": "props.optionsmethod"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "value": {
          "type": "code",
          "value": "props.ClinicalTermTeaching?.disc_teaching4?.main_method"
        }
      },
      "seq": 285,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 286,
      "name": "Dropdown",
      "parent": 275,
      "props": {
        "allowAdditions": {
          "type": "code",
          "value": "true"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-Dropdown-286"
        },
        "multiple": {
          "type": "code",
          "value": "true"
        },
        "name": {
          "type": "value",
          "value": "knowledge"
        },
        "onAddItem": {
          "type": "code",
          "value": "props.onAddOptions"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeValue(\"disc_teaching4.main_before\")"
        },
        "options": {
          "type": "code",
          "value": "props.optionstype"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "value": {
          "type": "code",
          "value": "props.ClinicalTermTeaching?.disc_teaching4?.main_before"
        }
      },
      "seq": 286,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 289,
      "name": "Dropdown",
      "parent": 278,
      "props": {
        "allowAdditions": {
          "type": "code",
          "value": "true"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-Dropdown-289"
        },
        "multiple": {
          "type": "code",
          "value": "true"
        },
        "name": {
          "type": "value",
          "value": "knowledge"
        },
        "onAddItem": {
          "type": "code",
          "value": "props.onAddOptions"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeValue(\"disc_teaching4.main_first\")"
        },
        "options": {
          "type": "code",
          "value": "props.optionstype"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "value": {
          "type": "code",
          "value": "props.ClinicalTermTeaching?.disc_teaching4?.main_first"
        }
      },
      "seq": 289,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 290,
      "name": "Dropdown",
      "parent": 279,
      "props": {
        "allowAdditions": {
          "type": "code",
          "value": "true"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-Dropdown-290"
        },
        "multiple": {
          "type": "code",
          "value": "true"
        },
        "name": {
          "type": "value",
          "value": "knowledge"
        },
        "onAddItem": {
          "type": "code",
          "value": "props.onAddOptions"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeValue(\"disc_teaching4.main_second\")"
        },
        "options": {
          "type": "code",
          "value": "props.optionstype"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "value": {
          "type": "code",
          "value": "props.ClinicalTermTeaching?.disc_teaching4?.main_second"
        }
      },
      "seq": 290,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 291,
      "name": "Dropdown",
      "parent": 281,
      "props": {
        "allowAdditions": {
          "type": "code",
          "value": "true"
        },
        "compact": {
          "type": "code",
          "value": ""
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-Dropdown-291"
        },
        "multiple": {
          "type": "code",
          "value": "true"
        },
        "name": {
          "type": "value",
          "value": "knowledge"
        },
        "onAddItem": {
          "type": "code",
          "value": "props.onAddOptions"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeValue(\"disc_teaching4.main_home\")"
        },
        "options": {
          "type": "code",
          "value": "props.optionstype"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "value": {
          "type": "code",
          "value": "props.ClinicalTermTeaching?.disc_teaching4?.main_home"
        }
      },
      "seq": 291,
      "void": false
    },
    {
      "from": null,
      "id": 294,
      "name": "div",
      "parent": 119,
      "props": {
        "children": {
          "type": "code",
          "value": "`5. ${props.ClinicalTermTeaching?.disc_teaching5?.name}`"
        },
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-div-294"
        },
        "style": {
          "type": "code",
          "value": "{ gridColumn: \"1/3\", fontWeight: \"bold\" ,display:\"flex\" }"
        }
      },
      "seq": 294,
      "void": false
    },
    {
      "from": null,
      "id": 295,
      "name": "div",
      "parent": 119,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-div-295"
        }
      },
      "seq": 295,
      "void": false
    },
    {
      "from": null,
      "id": 296,
      "name": "div",
      "parent": 119,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-div-296"
        }
      },
      "seq": 296,
      "void": false
    },
    {
      "from": null,
      "id": 297,
      "name": "div",
      "parent": 119,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-div-297"
        }
      },
      "seq": 297,
      "void": false
    },
    {
      "from": null,
      "id": 298,
      "name": "div",
      "parent": 119,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-div-298"
        }
      },
      "seq": 298,
      "void": false
    },
    {
      "from": null,
      "id": 299,
      "name": "div",
      "parent": 119,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-div-299"
        }
      },
      "seq": 299,
      "void": false
    },
    {
      "from": null,
      "id": 300,
      "name": "div",
      "parent": 119,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-div-300"
        }
      },
      "seq": 300,
      "void": false
    },
    {
      "from": null,
      "id": 301,
      "name": "div",
      "parent": 119,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-div-301"
        }
      },
      "seq": 301,
      "void": false
    },
    {
      "from": null,
      "id": 302,
      "name": "div",
      "parent": 119,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-div-302"
        }
      },
      "seq": 302,
      "void": false
    },
    {
      "from": null,
      "id": 303,
      "name": "div",
      "parent": 119,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-div-303"
        }
      },
      "seq": 303,
      "void": false
    },
    {
      "from": null,
      "id": 304,
      "name": "div",
      "parent": 119,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-div-304"
        }
      },
      "seq": 304,
      "void": false
    },
    {
      "from": null,
      "id": 305,
      "name": "div",
      "parent": 119,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-div-305"
        }
      },
      "seq": 305,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 306,
      "name": "Input",
      "parent": 296,
      "props": {
        "fluid": {
          "type": "code",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-Input-306"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeValue(\"disc_teaching5.main_relative_name\")"
        },
        "style": {
          "type": "code",
          "value": "{width:\"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.ClinicalTermTeaching?.disc_teaching5?.main_relative_name"
        }
      },
      "seq": 306,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 307,
      "name": "Dropdown",
      "parent": 295,
      "props": {
        "allowAdditions": {
          "type": "code",
          "value": "true"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-Dropdown-307"
        },
        "multiple": {
          "type": "code",
          "value": "true"
        },
        "name": {
          "type": "value",
          "value": "relative"
        },
        "onAddItem": {
          "type": "code",
          "value": "props.onAddOptions"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeValue(\"disc_teaching5.main_relative\")"
        },
        "options": {
          "type": "code",
          "value": "props.options"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "value": {
          "type": "code",
          "value": "props.ClinicalTermTeaching?.disc_teaching5?.main_relative"
        }
      },
      "seq": 307,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 308,
      "name": "Dropdown",
      "parent": 297,
      "props": {
        "allowAdditions": {
          "type": "code",
          "value": "true"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-Dropdown-308"
        },
        "multiple": {
          "type": "code",
          "value": "true"
        },
        "name": {
          "type": "value",
          "value": "method"
        },
        "onAddItem": {
          "type": "code",
          "value": "props.onAddOptions"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeValue(\"disc_teaching5.main_method\")"
        },
        "options": {
          "type": "code",
          "value": "props.optionsmethod"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "value": {
          "type": "code",
          "value": "props.ClinicalTermTeaching?.disc_teaching5?.main_method"
        }
      },
      "seq": 308,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 309,
      "name": "Dropdown",
      "parent": 298,
      "props": {
        "allowAdditions": {
          "type": "code",
          "value": "true"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-Dropdown-309"
        },
        "multiple": {
          "type": "code",
          "value": "true"
        },
        "name": {
          "type": "value",
          "value": "knowledge"
        },
        "onAddItem": {
          "type": "code",
          "value": "props.onAddOptions"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeValue(\"disc_teaching5.main_before\")"
        },
        "options": {
          "type": "code",
          "value": "props.optionstype"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "value": {
          "type": "code",
          "value": "props.ClinicalTermTeaching?.disc_teaching5?.main_before"
        }
      },
      "seq": 309,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 311,
      "name": "Dropdown",
      "parent": 300,
      "props": {
        "allowAdditions": {
          "type": "code",
          "value": "true"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-Dropdown-311"
        },
        "multiple": {
          "type": "code",
          "value": "true"
        },
        "name": {
          "type": "value",
          "value": "knowledge"
        },
        "onAddItem": {
          "type": "code",
          "value": "props.onAddOptions"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeValue(\"disc_teaching5.main_first\")"
        },
        "options": {
          "type": "code",
          "value": "props.optionstype"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "value": {
          "type": "code",
          "value": "props.ClinicalTermTeaching?.disc_teaching5?.main_first"
        }
      },
      "seq": 311,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 313,
      "name": "Dropdown",
      "parent": 302,
      "props": {
        "allowAdditions": {
          "type": "code",
          "value": "true"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-Dropdown-313"
        },
        "multiple": {
          "type": "code",
          "value": "true"
        },
        "name": {
          "type": "value",
          "value": "knowledge"
        },
        "onAddItem": {
          "type": "code",
          "value": "props.onAddOptions"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeValue(\"disc_teaching5.main_second\")"
        },
        "options": {
          "type": "code",
          "value": "props.optionstype"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "value": {
          "type": "code",
          "value": "props.ClinicalTermTeaching?.disc_teaching5?.main_second"
        }
      },
      "seq": 313,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 315,
      "name": "Dropdown",
      "parent": 304,
      "props": {
        "allowAdditions": {
          "type": "code",
          "value": "true"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-Dropdown-315"
        },
        "multiple": {
          "type": "code",
          "value": "true"
        },
        "name": {
          "type": "value",
          "value": "knowledge"
        },
        "onAddItem": {
          "type": "code",
          "value": "props.onAddOptions"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeValue(\"disc_teaching5.main_home\")"
        },
        "options": {
          "type": "code",
          "value": "props.optionstype"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "value": {
          "type": "code",
          "value": "props.ClinicalTermTeaching?.disc_teaching5?.main_home"
        }
      },
      "seq": 315,
      "void": false
    },
    {
      "from": null,
      "id": 317,
      "name": "div",
      "parent": 119,
      "props": {
        "children": {
          "type": "code",
          "value": "`6. ${props.ClinicalTermTeaching?.disc_teaching6?.name}`"
        },
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-div-317"
        },
        "style": {
          "type": "code",
          "value": "{ gridColumn: \"1/3\", fontWeight: \"bold\" ,display:\"flex\" }"
        }
      },
      "seq": 317,
      "void": false
    },
    {
      "from": null,
      "id": 318,
      "name": "div",
      "parent": 119,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-div-318"
        }
      },
      "seq": 318,
      "void": false
    },
    {
      "from": null,
      "id": 319,
      "name": "div",
      "parent": 119,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-div-319"
        }
      },
      "seq": 319,
      "void": false
    },
    {
      "from": null,
      "id": 320,
      "name": "div",
      "parent": 119,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-div-320"
        }
      },
      "seq": 320,
      "void": false
    },
    {
      "from": null,
      "id": 321,
      "name": "div",
      "parent": 119,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-div-321"
        },
        "style": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 321,
      "void": false
    },
    {
      "from": null,
      "id": 322,
      "name": "div",
      "parent": 119,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-div-322"
        }
      },
      "seq": 322,
      "void": false
    },
    {
      "from": null,
      "id": 323,
      "name": "div",
      "parent": 119,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-div-323"
        }
      },
      "seq": 323,
      "void": false
    },
    {
      "from": null,
      "id": 324,
      "name": "div",
      "parent": 119,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-div-324"
        }
      },
      "seq": 324,
      "void": false
    },
    {
      "from": null,
      "id": 325,
      "name": "div",
      "parent": 119,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-div-325"
        }
      },
      "seq": 325,
      "void": false
    },
    {
      "from": null,
      "id": 326,
      "name": "div",
      "parent": 119,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-div-326"
        }
      },
      "seq": 326,
      "void": false
    },
    {
      "from": null,
      "id": 327,
      "name": "div",
      "parent": 119,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-div-327"
        }
      },
      "seq": 327,
      "void": false
    },
    {
      "from": null,
      "id": 328,
      "name": "div",
      "parent": 119,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-div-328"
        }
      },
      "seq": 328,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 329,
      "name": "Input",
      "parent": 319,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-Input-329"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeValue(\"disc_teaching6.main_relative_name\")"
        },
        "style": {
          "type": "code",
          "value": "{width:\"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.ClinicalTermTeaching?.disc_teaching6?.main_relative_name"
        }
      },
      "seq": 329,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 330,
      "name": "Dropdown",
      "parent": 318,
      "props": {
        "allowAdditions": {
          "type": "code",
          "value": "true"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-Dropdown-330"
        },
        "multiple": {
          "type": "code",
          "value": "true"
        },
        "name": {
          "type": "value",
          "value": "relative"
        },
        "onAddItem": {
          "type": "code",
          "value": "props.onAddOptions"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeValue(\"disc_teaching6.main_relative\")"
        },
        "options": {
          "type": "code",
          "value": "props.options"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "value": {
          "type": "code",
          "value": "props.ClinicalTermTeaching?.disc_teaching6?.main_relative"
        }
      },
      "seq": 330,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 331,
      "name": "Dropdown",
      "parent": 320,
      "props": {
        "allowAdditions": {
          "type": "code",
          "value": "true"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-Dropdown-331"
        },
        "multiple": {
          "type": "code",
          "value": "true"
        },
        "name": {
          "type": "value",
          "value": "method"
        },
        "onAddItem": {
          "type": "code",
          "value": "props.onAddOptions"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeValue(\"disc_teaching6.main_method\")"
        },
        "options": {
          "type": "code",
          "value": "props.optionsmethod"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "value": {
          "type": "code",
          "value": "props.ClinicalTermTeaching?.disc_teaching6?.main_method"
        }
      },
      "seq": 331,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 332,
      "name": "Dropdown",
      "parent": 321,
      "props": {
        "allowAdditions": {
          "type": "code",
          "value": "true"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-Dropdown-332"
        },
        "multiple": {
          "type": "code",
          "value": "true"
        },
        "name": {
          "type": "value",
          "value": "knowledge"
        },
        "onAddItem": {
          "type": "code",
          "value": "props.onAddOptions"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeValue(\"disc_teaching6.main_before\")"
        },
        "options": {
          "type": "code",
          "value": "props.optionstype"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "value": {
          "type": "code",
          "value": "props.ClinicalTermTeaching?.disc_teaching6?.main_before"
        }
      },
      "seq": 332,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 334,
      "name": "Dropdown",
      "parent": 323,
      "props": {
        "allowAdditions": {
          "type": "code",
          "value": "true"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-Dropdown-334"
        },
        "multiple": {
          "type": "code",
          "value": "true"
        },
        "name": {
          "type": "value",
          "value": "knowledge"
        },
        "onAddItem": {
          "type": "code",
          "value": "props.onAddOptions"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeValue(\"disc_teaching6.main_first\")"
        },
        "options": {
          "type": "code",
          "value": "props.optionstype"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "value": {
          "type": "code",
          "value": "props.ClinicalTermTeaching?.disc_teaching6?.main_first"
        }
      },
      "seq": 334,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 336,
      "name": "Dropdown",
      "parent": 325,
      "props": {
        "allowAdditions": {
          "type": "code",
          "value": "true"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-Dropdown-336"
        },
        "multiple": {
          "type": "code",
          "value": "true"
        },
        "name": {
          "type": "value",
          "value": "knowledge"
        },
        "onAddItem": {
          "type": "code",
          "value": "props.onAddOptions"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeValue(\"disc_teaching6.main_second\")"
        },
        "options": {
          "type": "code",
          "value": "props.optionstype"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "value": {
          "type": "code",
          "value": "props.ClinicalTermTeaching?.disc_teaching6?.main_second"
        }
      },
      "seq": 336,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 338,
      "name": "Dropdown",
      "parent": 327,
      "props": {
        "allowAdditions": {
          "type": "code",
          "value": "true"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-Dropdown-338"
        },
        "multiple": {
          "type": "code",
          "value": "true"
        },
        "name": {
          "type": "value",
          "value": "knowledge"
        },
        "onAddItem": {
          "type": "code",
          "value": "props.onAddOptions"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeValue(\"disc_teaching6.main_home\")"
        },
        "options": {
          "type": "code",
          "value": "props.optionstype"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "value": {
          "type": "code",
          "value": "props.ClinicalTermTeaching?.disc_teaching6?.main_home"
        }
      },
      "seq": 338,
      "void": false
    },
    {
      "from": null,
      "id": 340,
      "name": "div",
      "parent": 119,
      "props": {
        "children": {
          "type": "code",
          "value": "`7. ${props.ClinicalTermTeaching?.disc_teaching7?.name}`"
        },
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-div-340"
        },
        "style": {
          "type": "code",
          "value": "{ gridColumn: \"1/3\", fontWeight: \"bold\" ,display:\"flex\" }"
        }
      },
      "seq": 340,
      "void": false
    },
    {
      "from": null,
      "id": 341,
      "name": "div",
      "parent": 119,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-div-341"
        }
      },
      "seq": 341,
      "void": false
    },
    {
      "from": null,
      "id": 342,
      "name": "div",
      "parent": 119,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-div-342"
        }
      },
      "seq": 342,
      "void": false
    },
    {
      "from": null,
      "id": 343,
      "name": "div",
      "parent": 119,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-div-343"
        }
      },
      "seq": 343,
      "void": false
    },
    {
      "from": null,
      "id": 344,
      "name": "div",
      "parent": 119,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-div-344"
        }
      },
      "seq": 344,
      "void": false
    },
    {
      "from": null,
      "id": 345,
      "name": "div",
      "parent": 119,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-div-345"
        }
      },
      "seq": 345,
      "void": false
    },
    {
      "from": null,
      "id": 346,
      "name": "div",
      "parent": 119,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-div-346"
        }
      },
      "seq": 346,
      "void": false
    },
    {
      "from": null,
      "id": 347,
      "name": "div",
      "parent": 119,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-div-347"
        }
      },
      "seq": 347,
      "void": false
    },
    {
      "from": null,
      "id": 348,
      "name": "div",
      "parent": 119,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-div-348"
        }
      },
      "seq": 348,
      "void": false
    },
    {
      "from": null,
      "id": 349,
      "name": "div",
      "parent": 119,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-div-349"
        }
      },
      "seq": 349,
      "void": false
    },
    {
      "from": null,
      "id": 350,
      "name": "div",
      "parent": 119,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-div-350"
        }
      },
      "seq": 350,
      "void": false
    },
    {
      "from": null,
      "id": 351,
      "name": "div",
      "parent": 119,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-div-351"
        }
      },
      "seq": 351,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 352,
      "name": "Input",
      "parent": 342,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-Input-352"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeValue(\"disc_teaching7.main_relative_name\")"
        },
        "style": {
          "type": "code",
          "value": "{width:\"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.ClinicalTermTeaching?.disc_teaching7?.main_relative_name"
        }
      },
      "seq": 352,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 353,
      "name": "Dropdown",
      "parent": 341,
      "props": {
        "allowAdditions": {
          "type": "code",
          "value": "true"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-Dropdown-353"
        },
        "multiple": {
          "type": "code",
          "value": "true"
        },
        "name": {
          "type": "value",
          "value": "relative"
        },
        "onAddItem": {
          "type": "code",
          "value": "props.onAddOptions"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeValue(\"disc_teaching7.main_relative\")"
        },
        "options": {
          "type": "code",
          "value": "props.options"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "value": {
          "type": "code",
          "value": "props.ClinicalTermTeaching?.disc_teaching7?.main_relative"
        }
      },
      "seq": 353,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 354,
      "name": "Dropdown",
      "parent": 343,
      "props": {
        "allowAdditions": {
          "type": "code",
          "value": "true"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-Dropdown-354"
        },
        "multiple": {
          "type": "code",
          "value": "true"
        },
        "name": {
          "type": "value",
          "value": "method"
        },
        "onAddItem": {
          "type": "code",
          "value": "props.onAddOptions"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeValue(\"disc_teaching7.main_method\")"
        },
        "options": {
          "type": "code",
          "value": "props.optionsmethod"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "value": {
          "type": "code",
          "value": "props.ClinicalTermTeaching?.disc_teaching7?.main_method"
        }
      },
      "seq": 354,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 355,
      "name": "Dropdown",
      "parent": 344,
      "props": {
        "allowAdditions": {
          "type": "code",
          "value": "true"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-Dropdown-355"
        },
        "multiple": {
          "type": "code",
          "value": "true"
        },
        "name": {
          "type": "value",
          "value": "knowledge"
        },
        "onAddItem": {
          "type": "code",
          "value": "props.onAddOptions"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeValue(\"disc_teaching7.main_before\")"
        },
        "options": {
          "type": "code",
          "value": "props.optionstype"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "value": {
          "type": "code",
          "value": "props.ClinicalTermTeaching?.disc_teaching7?.main_before"
        }
      },
      "seq": 355,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 357,
      "name": "Dropdown",
      "parent": 346,
      "props": {
        "allowAdditions": {
          "type": "code",
          "value": "true"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-Dropdown-357"
        },
        "multiple": {
          "type": "code",
          "value": "true"
        },
        "name": {
          "type": "value",
          "value": "knowledge"
        },
        "onAddItem": {
          "type": "code",
          "value": "props.onAddOptions"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeValue(\"disc_teaching7.main_first\")"
        },
        "options": {
          "type": "code",
          "value": "props.optionstype"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "value": {
          "type": "code",
          "value": "props.ClinicalTermTeaching?.disc_teaching7?.main_first"
        }
      },
      "seq": 357,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 359,
      "name": "Dropdown",
      "parent": 348,
      "props": {
        "allowAdditions": {
          "type": "code",
          "value": "true"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-Dropdown-359"
        },
        "multiple": {
          "type": "code",
          "value": "true"
        },
        "name": {
          "type": "value",
          "value": "knowledge"
        },
        "onAddItem": {
          "type": "code",
          "value": "props.onAddOptions"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeValue(\"disc_teaching7.main_second\")"
        },
        "options": {
          "type": "code",
          "value": "props.optionstype"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "value": {
          "type": "code",
          "value": "props.ClinicalTermTeaching?.disc_teaching7?.main_second"
        }
      },
      "seq": 359,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 361,
      "name": "Dropdown",
      "parent": 350,
      "props": {
        "allowAdditions": {
          "type": "code",
          "value": "true"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-Dropdown-361"
        },
        "multiple": {
          "type": "code",
          "value": "true"
        },
        "name": {
          "type": "value",
          "value": "knowledge"
        },
        "onAddItem": {
          "type": "code",
          "value": "props.onAddOptions"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeValue(\"disc_teaching7.main_home\")"
        },
        "options": {
          "type": "code",
          "value": "props.optionstype"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "value": {
          "type": "code",
          "value": "props.ClinicalTermTeaching?.disc_teaching7?.main_home"
        }
      },
      "seq": 361,
      "void": false
    },
    {
      "from": null,
      "id": 363,
      "name": "div",
      "parent": 119,
      "props": {
        "children": {
          "type": "code",
          "value": "`- ${props.ClinicalTermTeaching?.disc_teaching7?.items?.[0]?.name}`"
        },
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-div-363"
        },
        "style": {
          "type": "code",
          "value": "{ gridColumn: \"1/3\" ,display:\"flex\" }"
        }
      },
      "seq": 363,
      "void": false
    },
    {
      "from": null,
      "id": 364,
      "name": "div",
      "parent": 119,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-div-364"
        }
      },
      "seq": 364,
      "void": false
    },
    {
      "from": null,
      "id": 365,
      "name": "div",
      "parent": 119,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-div-365"
        }
      },
      "seq": 365,
      "void": false
    },
    {
      "from": null,
      "id": 366,
      "name": "div",
      "parent": 119,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-div-366"
        }
      },
      "seq": 366,
      "void": false
    },
    {
      "from": null,
      "id": 367,
      "name": "div",
      "parent": 119,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-div-367"
        }
      },
      "seq": 367,
      "void": false
    },
    {
      "from": null,
      "id": 368,
      "name": "div",
      "parent": 119,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-div-368"
        }
      },
      "seq": 368,
      "void": false
    },
    {
      "from": null,
      "id": 369,
      "name": "div",
      "parent": 119,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-div-369"
        }
      },
      "seq": 369,
      "void": false
    },
    {
      "from": null,
      "id": 370,
      "name": "div",
      "parent": 119,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-div-370"
        }
      },
      "seq": 370,
      "void": false
    },
    {
      "from": null,
      "id": 371,
      "name": "div",
      "parent": 119,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-div-371"
        }
      },
      "seq": 371,
      "void": false
    },
    {
      "from": null,
      "id": 372,
      "name": "div",
      "parent": 119,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-div-372"
        }
      },
      "seq": 372,
      "void": false
    },
    {
      "from": null,
      "id": 373,
      "name": "div",
      "parent": 119,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-div-373"
        }
      },
      "seq": 373,
      "void": false
    },
    {
      "from": null,
      "id": 374,
      "name": "div",
      "parent": 119,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-div-374"
        }
      },
      "seq": 374,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 375,
      "name": "Input",
      "parent": 365,
      "props": {
        "fluid": {
          "type": "code",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-Input-375"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeValue(\"disc_teaching7.items.0.sub_relative_name\")"
        },
        "style": {
          "type": "code",
          "value": "{width:\"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.ClinicalTermTeaching?.disc_teaching7?.items?.[0]?.sub_relative_name"
        }
      },
      "seq": 375,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 376,
      "name": "Dropdown",
      "parent": 364,
      "props": {
        "allowAdditions": {
          "type": "code",
          "value": "true"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-Dropdown-376"
        },
        "multiple": {
          "type": "code",
          "value": "true"
        },
        "name": {
          "type": "value",
          "value": "relative"
        },
        "onAddItem": {
          "type": "code",
          "value": "props.onAddOptions"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeValue(\"disc_teaching7.items.0.sub_relative\")"
        },
        "options": {
          "type": "code",
          "value": "props.options"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "value": {
          "type": "code",
          "value": "props.ClinicalTermTeaching?.disc_teaching7?.items?.[0]?.sub_relative"
        }
      },
      "seq": 376,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 377,
      "name": "Dropdown",
      "parent": 366,
      "props": {
        "allowAdditions": {
          "type": "code",
          "value": "true"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-Dropdown-377"
        },
        "multiple": {
          "type": "code",
          "value": "true"
        },
        "name": {
          "type": "value",
          "value": "method"
        },
        "onAddItem": {
          "type": "code",
          "value": "props.onAddOptions"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeValue(\"disc_teaching7.items.0.sub_method\")"
        },
        "options": {
          "type": "code",
          "value": "props.optionsmethod"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "value": {
          "type": "code",
          "value": "props.ClinicalTermTeaching?.disc_teaching7?.items?.[0]?.sub_method"
        }
      },
      "seq": 377,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 378,
      "name": "Dropdown",
      "parent": 367,
      "props": {
        "allowAdditions": {
          "type": "code",
          "value": "true"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-Dropdown-378"
        },
        "multiple": {
          "type": "code",
          "value": "true"
        },
        "name": {
          "type": "value",
          "value": "knowledge"
        },
        "onAddItem": {
          "type": "code",
          "value": "props.onAddOptions"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeValue(\"disc_teaching7.items.0.sub_before\")"
        },
        "options": {
          "type": "code",
          "value": "props.optionstype"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "value": {
          "type": "code",
          "value": "props.ClinicalTermTeaching?.disc_teaching7?.items?.[0]?.sub_before"
        }
      },
      "seq": 378,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 380,
      "name": "Dropdown",
      "parent": 369,
      "props": {
        "allowAdditions": {
          "type": "code",
          "value": "true"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-Dropdown-380"
        },
        "multiple": {
          "type": "code",
          "value": "true"
        },
        "name": {
          "type": "value",
          "value": "knowledge"
        },
        "onAddItem": {
          "type": "code",
          "value": "props.onAddOptions"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeValue(\"disc_teaching7.items.0.sub_first\")"
        },
        "options": {
          "type": "code",
          "value": "props.optionstype"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "value": {
          "type": "code",
          "value": "props.ClinicalTermTeaching?.disc_teaching7?.items?.[0]?.sub_first"
        }
      },
      "seq": 380,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 382,
      "name": "Dropdown",
      "parent": 371,
      "props": {
        "allowAdditions": {
          "type": "code",
          "value": "true"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-Dropdown-382"
        },
        "multiple": {
          "type": "code",
          "value": "true"
        },
        "name": {
          "type": "value",
          "value": "knowledge"
        },
        "onAddItem": {
          "type": "code",
          "value": "props.onAddOptions"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeValue(\"disc_teaching7.items.0.sub_second\")"
        },
        "options": {
          "type": "code",
          "value": "props.optionstype"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "value": {
          "type": "code",
          "value": "props.ClinicalTermTeaching?.disc_teaching7?.items?.[0]?.sub_second"
        }
      },
      "seq": 382,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 384,
      "name": "Dropdown",
      "parent": 373,
      "props": {
        "allowAdditions": {
          "type": "code",
          "value": "true"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-Dropdown-384"
        },
        "multiple": {
          "type": "code",
          "value": "true"
        },
        "name": {
          "type": "value",
          "value": "knowledge"
        },
        "onAddItem": {
          "type": "code",
          "value": "props.onAddOptions"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeValue(\"disc_teaching7.items.0.sub_home\")"
        },
        "options": {
          "type": "code",
          "value": "props.optionstype"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "value": {
          "type": "code",
          "value": "props.ClinicalTermTeaching?.disc_teaching7?.items?.[0]?.sub_home"
        }
      },
      "seq": 384,
      "void": false
    },
    {
      "from": null,
      "id": 386,
      "name": "div",
      "parent": 119,
      "props": {
        "children": {
          "type": "code",
          "value": "`- ${props.ClinicalTermTeaching?.disc_teaching7?.items?.[1]?.name}`"
        },
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-div-386"
        },
        "style": {
          "type": "code",
          "value": "{ gridColumn: \"1/3\" ,display:\"flex\" }"
        }
      },
      "seq": 386,
      "void": false
    },
    {
      "from": null,
      "id": 387,
      "name": "div",
      "parent": 119,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-div-387"
        }
      },
      "seq": 387,
      "void": false
    },
    {
      "from": null,
      "id": 388,
      "name": "div",
      "parent": 119,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-div-388"
        }
      },
      "seq": 388,
      "void": false
    },
    {
      "from": null,
      "id": 389,
      "name": "div",
      "parent": 119,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-div-389"
        },
        "style": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 389,
      "void": false
    },
    {
      "from": null,
      "id": 390,
      "name": "div",
      "parent": 119,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-div-390"
        }
      },
      "seq": 390,
      "void": false
    },
    {
      "from": null,
      "id": 391,
      "name": "div",
      "parent": 119,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-div-391"
        }
      },
      "seq": 391,
      "void": false
    },
    {
      "from": null,
      "id": 392,
      "name": "div",
      "parent": 119,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-div-392"
        }
      },
      "seq": 392,
      "void": false
    },
    {
      "from": null,
      "id": 393,
      "name": "div",
      "parent": 119,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-div-393"
        }
      },
      "seq": 393,
      "void": false
    },
    {
      "from": null,
      "id": 394,
      "name": "div",
      "parent": 119,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-div-394"
        }
      },
      "seq": 394,
      "void": false
    },
    {
      "from": null,
      "id": 395,
      "name": "div",
      "parent": 119,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-div-395"
        }
      },
      "seq": 395,
      "void": false
    },
    {
      "from": null,
      "id": 396,
      "name": "div",
      "parent": 119,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-div-396"
        }
      },
      "seq": 396,
      "void": false
    },
    {
      "from": null,
      "id": 397,
      "name": "div",
      "parent": 119,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-div-397"
        }
      },
      "seq": 397,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 398,
      "name": "Input",
      "parent": 388,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-Input-398"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeValue(\"disc_teaching7.items.1.sub_relative_name\")"
        },
        "style": {
          "type": "code",
          "value": "{width:\"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.ClinicalTermTeaching?.disc_teaching7?.items?.[1]?.sub_relative_name"
        }
      },
      "seq": 398,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 399,
      "name": "Dropdown",
      "parent": 387,
      "props": {
        "allowAdditions": {
          "type": "code",
          "value": "true"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-Dropdown-399"
        },
        "multiple": {
          "type": "code",
          "value": "true"
        },
        "name": {
          "type": "value",
          "value": "relative"
        },
        "onAddItem": {
          "type": "code",
          "value": "props.onAddOptions"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeValue(\"disc_teaching7.items.1.sub_relative\")"
        },
        "options": {
          "type": "code",
          "value": "props.options"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "value": {
          "type": "code",
          "value": "props.ClinicalTermTeaching?.disc_teaching7?.items?.[1]?.sub_relative"
        }
      },
      "seq": 399,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 400,
      "name": "Dropdown",
      "parent": 389,
      "props": {
        "allowAdditions": {
          "type": "code",
          "value": "true"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-Dropdown-400"
        },
        "multiple": {
          "type": "code",
          "value": "true"
        },
        "name": {
          "type": "value",
          "value": "method"
        },
        "onAddItem": {
          "type": "code",
          "value": "props.onAddOptions"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeValue(\"disc_teaching7.items.1.sub_method\")"
        },
        "options": {
          "type": "code",
          "value": "props.optionsmethod"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "value": {
          "type": "code",
          "value": "props.ClinicalTermTeaching?.disc_teaching7?.items?.[1]?.sub_method"
        }
      },
      "seq": 400,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 401,
      "name": "Dropdown",
      "parent": 390,
      "props": {
        "allowAdditions": {
          "type": "code",
          "value": "true"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-Dropdown-401"
        },
        "multiple": {
          "type": "code",
          "value": "true"
        },
        "name": {
          "type": "value",
          "value": "knowledge"
        },
        "onAddItem": {
          "type": "code",
          "value": "props.onAddOptions"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeValue(\"disc_teaching7.items.1.sub_before\")"
        },
        "options": {
          "type": "code",
          "value": "props.optionstype"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "value": {
          "type": "code",
          "value": "props.ClinicalTermTeaching?.disc_teaching7?.items?.[1]?.sub_before"
        }
      },
      "seq": 401,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 403,
      "name": "Dropdown",
      "parent": 392,
      "props": {
        "allowAdditions": {
          "type": "code",
          "value": "true"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-Dropdown-403"
        },
        "multiple": {
          "type": "code",
          "value": "true"
        },
        "name": {
          "type": "value",
          "value": "knowledge"
        },
        "onAddItem": {
          "type": "code",
          "value": "props.onAddOptions"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeValue(\"disc_teaching7.items.1.sub_first\")"
        },
        "options": {
          "type": "code",
          "value": "props.optionstype"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "value": {
          "type": "code",
          "value": "props.ClinicalTermTeaching?.disc_teaching7?.items?.[1]?.sub_first"
        }
      },
      "seq": 403,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 405,
      "name": "Dropdown",
      "parent": 394,
      "props": {
        "allowAdditions": {
          "type": "code",
          "value": "true"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-Dropdown-405"
        },
        "multiple": {
          "type": "code",
          "value": "true"
        },
        "name": {
          "type": "value",
          "value": "knowledge"
        },
        "onAddItem": {
          "type": "code",
          "value": "props.onAddOptions"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeValue(\"disc_teaching7.items.1.sub_second\")"
        },
        "options": {
          "type": "code",
          "value": "props.optionstype"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "value": {
          "type": "code",
          "value": "props.ClinicalTermTeaching?.disc_teaching7?.items?.[1]?.sub_second"
        }
      },
      "seq": 405,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 407,
      "name": "Dropdown",
      "parent": 396,
      "props": {
        "allowAdditions": {
          "type": "code",
          "value": "true"
        },
        "disabled": {
          "type": "value",
          "value": ""
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-Dropdown-407"
        },
        "multiple": {
          "type": "code",
          "value": "true"
        },
        "name": {
          "type": "value",
          "value": "knowledge"
        },
        "onAddItem": {
          "type": "code",
          "value": "props.onAddOptions"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeValue(\"disc_teaching7.items.1.sub_home\")"
        },
        "options": {
          "type": "code",
          "value": "props.optionstype"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "value": {
          "type": "code",
          "value": "props.ClinicalTermTeaching?.disc_teaching7?.items?.[1]?.sub_home"
        }
      },
      "seq": 407,
      "void": false
    },
    {
      "from": null,
      "id": 409,
      "name": "div",
      "parent": 119,
      "props": {
        "children": {
          "type": "code",
          "value": "`- ${props.ClinicalTermTeaching?.disc_teaching7?.items?.[2]?.name}`"
        },
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-div-409"
        },
        "style": {
          "type": "code",
          "value": "{ gridColumn: \"1/3\" ,display:\"flex\" }"
        }
      },
      "seq": 409,
      "void": false
    },
    {
      "from": null,
      "id": 410,
      "name": "div",
      "parent": 119,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-div-410"
        }
      },
      "seq": 410,
      "void": false
    },
    {
      "from": null,
      "id": 411,
      "name": "div",
      "parent": 119,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-div-411"
        }
      },
      "seq": 411,
      "void": false
    },
    {
      "from": null,
      "id": 412,
      "name": "div",
      "parent": 119,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-div-412"
        }
      },
      "seq": 412,
      "void": false
    },
    {
      "from": null,
      "id": 413,
      "name": "div",
      "parent": 119,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-div-413"
        }
      },
      "seq": 413,
      "void": false
    },
    {
      "from": null,
      "id": 414,
      "name": "div",
      "parent": 119,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-div-414"
        }
      },
      "seq": 414,
      "void": false
    },
    {
      "from": null,
      "id": 415,
      "name": "div",
      "parent": 119,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-div-415"
        }
      },
      "seq": 415,
      "void": false
    },
    {
      "from": null,
      "id": 416,
      "name": "div",
      "parent": 119,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-div-416"
        }
      },
      "seq": 416,
      "void": false
    },
    {
      "from": null,
      "id": 417,
      "name": "div",
      "parent": 119,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-div-417"
        }
      },
      "seq": 417,
      "void": false
    },
    {
      "from": null,
      "id": 418,
      "name": "div",
      "parent": 119,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-div-418"
        }
      },
      "seq": 418,
      "void": false
    },
    {
      "from": null,
      "id": 419,
      "name": "div",
      "parent": 119,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-div-419"
        }
      },
      "seq": 419,
      "void": false
    },
    {
      "from": null,
      "id": 420,
      "name": "div",
      "parent": 119,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-div-420"
        }
      },
      "seq": 420,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 421,
      "name": "Input",
      "parent": 411,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-Input-421"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeValue(\"disc_teaching7.items.2.sub_relative_name\")"
        },
        "style": {
          "type": "code",
          "value": "{width:\"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.ClinicalTermTeaching?.disc_teaching7?.items?.[2]?.sub_relative_name"
        }
      },
      "seq": 421,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 422,
      "name": "Dropdown",
      "parent": 410,
      "props": {
        "allowAdditions": {
          "type": "code",
          "value": "true"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-Dropdown-422"
        },
        "multiple": {
          "type": "code",
          "value": "true"
        },
        "name": {
          "type": "value",
          "value": "relative"
        },
        "onAddItem": {
          "type": "code",
          "value": "props.onAddOptions"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeValue(\"disc_teaching7.items.2.sub_relative\")"
        },
        "options": {
          "type": "code",
          "value": "props.options"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "value": {
          "type": "code",
          "value": "props.ClinicalTermTeaching?.disc_teaching7?.items?.[2]?.sub_relative"
        }
      },
      "seq": 422,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 423,
      "name": "Dropdown",
      "parent": 412,
      "props": {
        "allowAdditions": {
          "type": "code",
          "value": "true"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-Dropdown-423"
        },
        "multiple": {
          "type": "code",
          "value": "true"
        },
        "name": {
          "type": "value",
          "value": "method"
        },
        "onAddItem": {
          "type": "code",
          "value": "props.onAddOptions"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeValue(\"disc_teaching7.items.2.sub_method\")"
        },
        "options": {
          "type": "code",
          "value": "props.optionsmethod"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "value": {
          "type": "code",
          "value": "props.ClinicalTermTeaching?.disc_teaching7?.items?.[2]?.sub_method"
        }
      },
      "seq": 423,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 424,
      "name": "Dropdown",
      "parent": 413,
      "props": {
        "allowAdditions": {
          "type": "code",
          "value": "true"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-Dropdown-424"
        },
        "multiple": {
          "type": "code",
          "value": "true"
        },
        "name": {
          "type": "value",
          "value": "knowledge"
        },
        "onAddItem": {
          "type": "code",
          "value": "props.onAddOptions"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeValue(\"disc_teaching7.items.2.sub_before\")"
        },
        "options": {
          "type": "code",
          "value": "props.optionstype"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "value": {
          "type": "code",
          "value": "props.ClinicalTermTeaching?.disc_teaching7?.items?.[2]?.sub_before"
        }
      },
      "seq": 424,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 426,
      "name": "Dropdown",
      "parent": 415,
      "props": {
        "allowAdditions": {
          "type": "code",
          "value": "true"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-Dropdown-426"
        },
        "multiple": {
          "type": "code",
          "value": "true"
        },
        "name": {
          "type": "value",
          "value": "knowledge"
        },
        "onAddItem": {
          "type": "code",
          "value": "props.onAddOptions"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeValue(\"disc_teaching7.items.2.sub_first\")"
        },
        "options": {
          "type": "code",
          "value": "props.optionstype"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "value": {
          "type": "code",
          "value": "props.ClinicalTermTeaching?.disc_teaching7?.items?.[2]?.sub_first"
        }
      },
      "seq": 426,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 428,
      "name": "Dropdown",
      "parent": 417,
      "props": {
        "allowAdditions": {
          "type": "code",
          "value": "true"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-Dropdown-428"
        },
        "multiple": {
          "type": "code",
          "value": "true"
        },
        "name": {
          "type": "value",
          "value": "knowledge"
        },
        "onAddItem": {
          "type": "code",
          "value": "props.onAddOptions"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeValue(\"disc_teaching7.items.2.sub_second\")"
        },
        "options": {
          "type": "code",
          "value": "props.optionstype"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "value": {
          "type": "code",
          "value": "props.ClinicalTermTeaching?.disc_teaching7?.items?.[2]?.sub_second"
        }
      },
      "seq": 428,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 430,
      "name": "Dropdown",
      "parent": 419,
      "props": {
        "allowAdditions": {
          "type": "code",
          "value": "true"
        },
        "clearable": {
          "type": "value",
          "value": ""
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-Dropdown-430"
        },
        "multiple": {
          "type": "code",
          "value": "true"
        },
        "name": {
          "type": "value",
          "value": "knowledge"
        },
        "onAddItem": {
          "type": "code",
          "value": "props.onAddOptions"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeValue(\"disc_teaching7.items.2.sub_home\")"
        },
        "options": {
          "type": "code",
          "value": "props.optionstype"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "value": {
          "type": "code",
          "value": "props.ClinicalTermTeaching?.disc_teaching7?.items?.[2]?.sub_home"
        }
      },
      "seq": 430,
      "void": false
    },
    {
      "from": null,
      "id": 432,
      "name": "div",
      "parent": 119,
      "props": {
        "children": {
          "type": "code",
          "value": "`8. ${props.ClinicalTermTeaching?.disc_teaching8?.name}`"
        },
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-div-432"
        },
        "style": {
          "type": "code",
          "value": "{ gridColumn: \"1/3\", fontWeight: \"bold\" ,display:\"flex\" }"
        }
      },
      "seq": 432,
      "void": false
    },
    {
      "from": null,
      "id": 433,
      "name": "div",
      "parent": 119,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-div-433"
        }
      },
      "seq": 433,
      "void": false
    },
    {
      "from": null,
      "id": 434,
      "name": "div",
      "parent": 119,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-div-434"
        }
      },
      "seq": 434,
      "void": false
    },
    {
      "from": null,
      "id": 435,
      "name": "div",
      "parent": 119,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-div-435"
        }
      },
      "seq": 435,
      "void": false
    },
    {
      "from": null,
      "id": 436,
      "name": "div",
      "parent": 119,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-div-436"
        }
      },
      "seq": 436,
      "void": false
    },
    {
      "from": null,
      "id": 437,
      "name": "div",
      "parent": 119,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-div-437"
        }
      },
      "seq": 437,
      "void": false
    },
    {
      "from": null,
      "id": 438,
      "name": "div",
      "parent": 119,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-div-438"
        }
      },
      "seq": 438,
      "void": false
    },
    {
      "from": null,
      "id": 439,
      "name": "div",
      "parent": 119,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-div-439"
        }
      },
      "seq": 439,
      "void": false
    },
    {
      "from": null,
      "id": 440,
      "name": "div",
      "parent": 119,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-div-440"
        }
      },
      "seq": 440,
      "void": false
    },
    {
      "from": null,
      "id": 441,
      "name": "div",
      "parent": 119,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-div-441"
        },
        "style": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 441,
      "void": false
    },
    {
      "from": null,
      "id": 442,
      "name": "div",
      "parent": 119,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-div-442"
        }
      },
      "seq": 442,
      "void": false
    },
    {
      "from": null,
      "id": 443,
      "name": "div",
      "parent": 119,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-div-443"
        }
      },
      "seq": 443,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 444,
      "name": "Input",
      "parent": 434,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-Input-444"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeValue(\"disc_teaching8.main_relative_name\")"
        },
        "style": {
          "type": "code",
          "value": "{width:\"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.ClinicalTermTeaching?.disc_teaching8?.main_relative_name"
        }
      },
      "seq": 444,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 445,
      "name": "Dropdown",
      "parent": 433,
      "props": {
        "allowAdditions": {
          "type": "code",
          "value": "true"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-Dropdown-445"
        },
        "multiple": {
          "type": "code",
          "value": "true"
        },
        "name": {
          "type": "value",
          "value": "relative"
        },
        "onAddItem": {
          "type": "code",
          "value": "props.onAddOptions"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeValue(\"disc_teaching8.main_relative\")"
        },
        "options": {
          "type": "code",
          "value": "props.options"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "value": {
          "type": "code",
          "value": "props.ClinicalTermTeaching?.disc_teaching8?.main_relative"
        }
      },
      "seq": 445,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 446,
      "name": "Dropdown",
      "parent": 435,
      "props": {
        "allowAdditions": {
          "type": "code",
          "value": "true"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-Dropdown-446"
        },
        "multiple": {
          "type": "code",
          "value": "true"
        },
        "name": {
          "type": "value",
          "value": "method"
        },
        "onAddItem": {
          "type": "code",
          "value": "props.onAddOptions"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeValue(\"disc_teaching8.main_method\")"
        },
        "options": {
          "type": "code",
          "value": "props.optionsmethod"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "value": {
          "type": "code",
          "value": "props.ClinicalTermTeaching?.disc_teaching8?.main_method"
        }
      },
      "seq": 446,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 447,
      "name": "Dropdown",
      "parent": 436,
      "props": {
        "allowAdditions": {
          "type": "code",
          "value": "true"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-Dropdown-447"
        },
        "multiple": {
          "type": "code",
          "value": "true"
        },
        "name": {
          "type": "value",
          "value": "knowledge"
        },
        "onAddItem": {
          "type": "code",
          "value": "props.onAddOptions"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeValue(\"disc_teaching8.main_before\")"
        },
        "options": {
          "type": "code",
          "value": "props.optionstype"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "value": {
          "type": "code",
          "value": "props.ClinicalTermTeaching?.disc_teaching8?.main_before"
        }
      },
      "seq": 447,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 449,
      "name": "Dropdown",
      "parent": 438,
      "props": {
        "allowAdditions": {
          "type": "code",
          "value": "true"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-Dropdown-449"
        },
        "multiple": {
          "type": "code",
          "value": "true"
        },
        "name": {
          "type": "value",
          "value": "knowledge"
        },
        "onAddItem": {
          "type": "code",
          "value": "props.onAddOptions"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeValue(\"disc_teaching8.main_first\")"
        },
        "options": {
          "type": "code",
          "value": "props.optionstype"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "value": {
          "type": "code",
          "value": "props.ClinicalTermTeaching?.disc_teaching8?.main_first"
        }
      },
      "seq": 449,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 451,
      "name": "Dropdown",
      "parent": 440,
      "props": {
        "allowAdditions": {
          "type": "code",
          "value": "true"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-Dropdown-451"
        },
        "multiple": {
          "type": "code",
          "value": "true"
        },
        "name": {
          "type": "value",
          "value": "knowledge"
        },
        "onAddItem": {
          "type": "code",
          "value": "props.onAddOptions"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeValue(\"disc_teaching8.main_second\")"
        },
        "options": {
          "type": "code",
          "value": "props.optionstype"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "value": {
          "type": "code",
          "value": "props.ClinicalTermTeaching?.disc_teaching8?.main_second"
        }
      },
      "seq": 451,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 453,
      "name": "Dropdown",
      "parent": 442,
      "props": {
        "allowAdditions": {
          "type": "code",
          "value": "true"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-Dropdown-453"
        },
        "multiple": {
          "type": "code",
          "value": "true"
        },
        "name": {
          "type": "value",
          "value": "knowledge"
        },
        "onAddItem": {
          "type": "code",
          "value": "props.onAddOptions"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeValue(\"disc_teaching8.main_home\")"
        },
        "options": {
          "type": "code",
          "value": "props.optionstype"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "value": {
          "type": "code",
          "value": "props.ClinicalTermTeaching?.disc_teaching8?.main_home"
        }
      },
      "seq": 453,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 455,
      "name": "Input",
      "parent": 138,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-Input-455"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeValue(\"disc_teaching1.main_before_user_name\")"
        },
        "style": {
          "type": "code",
          "value": "{width:\"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.ClinicalTermTeaching?.disc_teaching1?.main_before_user_name"
        }
      },
      "seq": 455,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 456,
      "name": "Input",
      "parent": 161,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-Input-456"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeValue(\"disc_teaching1.items.0.sub_before_user_name\")"
        },
        "style": {
          "type": "code",
          "value": "{width:\"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.ClinicalTermTeaching?.disc_teaching1?.items?.[0]?.sub_before_user_name"
        }
      },
      "seq": 456,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 457,
      "name": "Input",
      "parent": 184,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-Input-457"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeValue(\"disc_teaching1.items.1.sub_before_user_name\")"
        },
        "style": {
          "type": "code",
          "value": "{width:\"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.ClinicalTermTeaching?.disc_teaching1?.items?.[1]?.sub_before_user_name"
        }
      },
      "seq": 457,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 458,
      "name": "Input",
      "parent": 207,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-Input-458"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeValue(\"disc_teaching1.items.2.sub_before_user_name\")"
        },
        "style": {
          "type": "code",
          "value": "{width:\"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.ClinicalTermTeaching?.disc_teaching1?.items?.[2]?.sub_before_user_name"
        }
      },
      "seq": 458,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 459,
      "name": "Input",
      "parent": 230,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-Input-459"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeValue(\"disc_teaching2.main_before_user_name\")"
        },
        "style": {
          "type": "code",
          "value": "{width:\"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.ClinicalTermTeaching?.disc_teaching2?.main_before_user_name"
        }
      },
      "seq": 459,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 460,
      "name": "Input",
      "parent": 253,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-Input-460"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeValue(\"disc_teaching3.main_before_user_name\")"
        },
        "style": {
          "type": "code",
          "value": "{width:\"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.ClinicalTermTeaching?.disc_teaching3?.main_before_user_name"
        }
      },
      "seq": 460,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 461,
      "name": "Input",
      "parent": 276,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-Input-461"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeValue(\"disc_teaching4.main_before_user_name\")"
        },
        "style": {
          "type": "code",
          "value": "{width:\"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.ClinicalTermTeaching?.disc_teaching4?.main_before_user_name"
        }
      },
      "seq": 461,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 462,
      "name": "Input",
      "parent": 299,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-Input-462"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeValue(\"disc_teaching5.main_before_user_name\")"
        },
        "style": {
          "type": "code",
          "value": "{width:\"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.ClinicalTermTeaching?.disc_teaching5?.main_before_user_name"
        }
      },
      "seq": 462,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 463,
      "name": "Input",
      "parent": 322,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-Input-463"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeValue(\"disc_teaching6.main_before_user_name\")"
        },
        "style": {
          "type": "code",
          "value": "{width:\"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.ClinicalTermTeaching?.disc_teaching6?.main_before_user_name"
        }
      },
      "seq": 463,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 464,
      "name": "Input",
      "parent": 345,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-Input-464"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeValue(\"disc_teaching7.main_before_user_name\")"
        },
        "style": {
          "type": "code",
          "value": "{width:\"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.ClinicalTermTeaching?.disc_teaching7?.main_before_user_name"
        }
      },
      "seq": 464,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 465,
      "name": "Input",
      "parent": 368,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-Input-465"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeValue(\"disc_teaching7.items.0.sub_before_user_name\")"
        },
        "style": {
          "type": "code",
          "value": "{width:\"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.ClinicalTermTeaching?.disc_teaching7?.items?.[0]?.sub_before_user_name"
        }
      },
      "seq": 465,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 466,
      "name": "Input",
      "parent": 391,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-Input-466"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeValue(\"disc_teaching7.items.1.sub_before_user_name\")"
        },
        "style": {
          "type": "code",
          "value": "{width:\"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.ClinicalTermTeaching?.disc_teaching7?.items?.[1]?.sub_before_user_name"
        }
      },
      "seq": 466,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 467,
      "name": "Input",
      "parent": 414,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-Input-467"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeValue(\"disc_teaching7.items.2.sub_before_user_name\")"
        },
        "style": {
          "type": "code",
          "value": "{width:\"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.ClinicalTermTeaching?.disc_teaching7?.items?.[2]?.sub_before_user_name"
        }
      },
      "seq": 467,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 468,
      "name": "Input",
      "parent": 437,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-Input-468"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeValue(\"disc_teaching8.main_before_user_name\")"
        },
        "style": {
          "type": "code",
          "value": "{width:\"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.ClinicalTermTeaching?.disc_teaching8?.main_before_user_name"
        }
      },
      "seq": 468,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 469,
      "name": "Input",
      "parent": 140,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-Input-469"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeValue(\"disc_teaching1.main_first_user_name\")"
        },
        "style": {
          "type": "code",
          "value": "{width:\"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.ClinicalTermTeaching?.disc_teaching1?.main_first_user_name"
        }
      },
      "seq": 469,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 470,
      "name": "Input",
      "parent": 163,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-Input-470"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeValue(\"disc_teaching1.items.0.sub_first_user_name\")"
        },
        "style": {
          "type": "code",
          "value": "{width:\"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.ClinicalTermTeaching?.disc_teaching1?.items?.[0]?.sub_first_user_name"
        }
      },
      "seq": 470,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 471,
      "name": "Input",
      "parent": 186,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-Input-471"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeValue(\"disc_teaching1.items.1.sub_first_user_name\")"
        },
        "style": {
          "type": "code",
          "value": "{width:\"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.ClinicalTermTeaching?.disc_teaching1?.items?.[1]?.sub_first_user_name"
        }
      },
      "seq": 471,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 472,
      "name": "Input",
      "parent": 209,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-Input-472"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeValue(\"disc_teaching1.items.2.sub_first_user_name\")"
        },
        "style": {
          "type": "code",
          "value": "{width:\"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.ClinicalTermTeaching?.disc_teaching1?.items?.[2]?.sub_first_user_name"
        }
      },
      "seq": 472,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 473,
      "name": "Input",
      "parent": 232,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-Input-473"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeValue(\"disc_teaching2.main_first_user_name\")"
        },
        "style": {
          "type": "code",
          "value": "{width:\"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.ClinicalTermTeaching?.disc_teaching2?.main_first_user_name",
          "valueEN": ""
        }
      },
      "seq": 473,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 474,
      "name": "Input",
      "parent": 255,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-Input-474"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeValue(\"disc_teaching3.main_first_user_name\")"
        },
        "style": {
          "type": "code",
          "value": "{width:\"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.ClinicalTermTeaching?.disc_teaching3?.main_first_user_name"
        }
      },
      "seq": 474,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 475,
      "name": "Input",
      "parent": 277,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-Input-475"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeValue(\"disc_teaching4.main_first_user_name\")"
        },
        "style": {
          "type": "code",
          "value": "{width:\"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.ClinicalTermTeaching?.disc_teaching4?.main_first_user_name"
        }
      },
      "seq": 475,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 476,
      "name": "Input",
      "parent": 301,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-Input-476"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeValue(\"disc_teaching5.main_first_user_name\")"
        },
        "style": {
          "type": "code",
          "value": "{width:\"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.ClinicalTermTeaching?.disc_teaching5?.main_first_user_name"
        }
      },
      "seq": 476,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 477,
      "name": "Input",
      "parent": 324,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-Input-477"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeValue(\"disc_teaching6.main_first_user_name\")"
        },
        "style": {
          "type": "code",
          "value": "{width:\"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.ClinicalTermTeaching?.disc_teaching6?.main_first_user_name"
        }
      },
      "seq": 477,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 478,
      "name": "Input",
      "parent": 347,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-Input-478"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeValue(\"disc_teaching7.main_first_user_name\")"
        },
        "style": {
          "type": "code",
          "value": "{width:\"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.ClinicalTermTeaching?.disc_teaching7?.main_first_user_name"
        }
      },
      "seq": 478,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 479,
      "name": "Input",
      "parent": 370,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-Input-479"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeValue(\"disc_teaching7.items.0.sub_first_user_name\")"
        },
        "style": {
          "type": "code",
          "value": "{width:\"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.ClinicalTermTeaching?.disc_teaching7?.items?.[0]?.sub_first_user_name"
        }
      },
      "seq": 479,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 480,
      "name": "Input",
      "parent": 393,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-Input-480"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeValue(\"disc_teaching7.items.1.sub_first_user_name\")"
        },
        "style": {
          "type": "code",
          "value": "{width:\"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.ClinicalTermTeaching?.disc_teaching7?.items?.[1]?.sub_first_user_name"
        }
      },
      "seq": 480,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 481,
      "name": "Input",
      "parent": 416,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-Input-481"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeValue(\"disc_teaching7.items.2.sub_first_user_name\")"
        },
        "style": {
          "type": "code",
          "value": "{width:\"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.ClinicalTermTeaching?.disc_teaching7?.items?.[2]?.sub_first_user_name"
        }
      },
      "seq": 481,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 482,
      "name": "Input",
      "parent": 439,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-Input-482"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeValue(\"disc_teaching8.main_first_user_name\")"
        },
        "style": {
          "type": "code",
          "value": "{width:\"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.ClinicalTermTeaching?.disc_teaching8?.main_first_user_name"
        }
      },
      "seq": 482,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 483,
      "name": "Input",
      "parent": 142,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-Input-483"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeValue(\"disc_teaching1.main_second_user_name\")"
        },
        "style": {
          "type": "code",
          "value": "{width:\"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.ClinicalTermTeaching?.disc_teaching1?.main_second_user_name"
        }
      },
      "seq": 483,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 484,
      "name": "Input",
      "parent": 165,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-Input-484"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeValue(\"disc_teaching1.items.0.sub_second_user_name\")"
        },
        "style": {
          "type": "code",
          "value": "{width:\"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.ClinicalTermTeaching?.disc_teaching1?.items?.[0]?.sub_second_user_name"
        }
      },
      "seq": 484,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 485,
      "name": "Input",
      "parent": 188,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-Input-485"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeValue(\"disc_teaching1.items.1.sub_second_user_name\")"
        },
        "style": {
          "type": "code",
          "value": "{width:\"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.ClinicalTermTeaching?.disc_teaching1?.items?.[1]?.sub_second_user_name"
        }
      },
      "seq": 485,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 486,
      "name": "Input",
      "parent": 211,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-Input-486"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeValue(\"disc_teaching1.items.2.sub_second_user_name\")"
        },
        "style": {
          "type": "code",
          "value": "{width:\"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.ClinicalTermTeaching?.disc_teaching1?.items?.[2]?.sub_second_user_name"
        }
      },
      "seq": 486,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 487,
      "name": "Input",
      "parent": 234,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-Input-487"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeValue(\"disc_teaching2.main_second_user_name\")"
        },
        "style": {
          "type": "code",
          "value": "{width:\"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.ClinicalTermTeaching?.disc_teaching2?.main_second_user_name"
        }
      },
      "seq": 487,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 488,
      "name": "Input",
      "parent": 257,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-Input-488"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeValue(\"disc_teaching3.main_second_user_name\")"
        },
        "style": {
          "type": "code",
          "value": "{width:\"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.ClinicalTermTeaching?.disc_teaching3?.main_second_user_name"
        }
      },
      "seq": 488,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 489,
      "name": "Input",
      "parent": 154,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-Input-489"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeValue(\"disc_teaching1.main_home_user_name\")"
        },
        "style": {
          "type": "code",
          "value": "{width:\"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.ClinicalTermTeaching?.disc_teaching1?.main_home_user_name"
        }
      },
      "seq": 489,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 491,
      "name": "Input",
      "parent": 167,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-Input-491"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeValue(\"disc_teaching1.items.0.sub_home_user_name\")"
        },
        "style": {
          "type": "code",
          "value": "{width:\"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.ClinicalTermTeaching?.disc_teaching1?.items?.[0]?.sub_home_user_name"
        }
      },
      "seq": 491,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 492,
      "name": "Input",
      "parent": 190,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-Input-492"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeValue(\"disc_teaching1.items.1.sub_home_user_name\")"
        },
        "style": {
          "type": "code",
          "value": "{width:\"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.ClinicalTermTeaching?.disc_teaching1?.items?.[1]?.sub_home_user_name"
        }
      },
      "seq": 492,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 493,
      "name": "Input",
      "parent": 213,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-Input-493"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeValue(\"disc_teaching1.items.2.sub_home_user_name\")"
        },
        "style": {
          "type": "code",
          "value": "{width:\"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.ClinicalTermTeaching?.disc_teaching1?.items?.[2]?.sub_home_user_name"
        }
      },
      "seq": 493,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 495,
      "name": "Input",
      "parent": 280,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-Input-495"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeValue(\"disc_teaching4.main_second_user_name\")"
        },
        "style": {
          "type": "code",
          "value": "{width:\"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.ClinicalTermTeaching?.disc_teaching4?.main_second_user_name"
        }
      },
      "seq": 495,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 496,
      "name": "Input",
      "parent": 303,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-Input-496"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeValue(\"disc_teaching5.main_second_user_name\")"
        },
        "style": {
          "type": "code",
          "value": "{width:\"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.ClinicalTermTeaching?.disc_teaching5?.main_second_user_name"
        }
      },
      "seq": 496,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 497,
      "name": "Input",
      "parent": 326,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-Input-497"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeValue(\"disc_teaching6.main_second_user_name\")"
        },
        "style": {
          "type": "code",
          "value": "{width:\"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.ClinicalTermTeaching?.disc_teaching6?.main_second_user_name"
        }
      },
      "seq": 497,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 498,
      "name": "Input",
      "parent": 349,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-Input-498"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeValue(\"disc_teaching7.main_second_user_name\")"
        },
        "style": {
          "type": "code",
          "value": "{width:\"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.ClinicalTermTeaching?.disc_teaching7?.main_second_user_name"
        }
      },
      "seq": 498,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 499,
      "name": "Input",
      "parent": 372,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-Input-499"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeValue(\"disc_teaching7.items.0.sub_second_user_name\")"
        },
        "style": {
          "type": "code",
          "value": "{width:\"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.ClinicalTermTeaching?.disc_teaching7?.items?.[0]?.sub_second_user_name"
        }
      },
      "seq": 499,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 500,
      "name": "Input",
      "parent": 395,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-Input-500"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeValue(\"disc_teaching7.items.1.sub_second_user_name\")"
        },
        "style": {
          "type": "code",
          "value": "{width:\"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.ClinicalTermTeaching?.disc_teaching7?.items?.[1]?.sub_second_user_name"
        }
      },
      "seq": 500,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 501,
      "name": "Input",
      "parent": 418,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-Input-501"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeValue(\"disc_teaching7.items.2.sub_second_user_name\")"
        },
        "style": {
          "type": "code",
          "value": "{width:\"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.ClinicalTermTeaching?.disc_teaching7?.items?.[2]?.sub_second_user_name"
        }
      },
      "seq": 501,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 502,
      "name": "Input",
      "parent": 441,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-Input-502"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeValue(\"disc_teaching8.main_second_user_name\")"
        },
        "style": {
          "type": "code",
          "value": "{width:\"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.ClinicalTermTeaching?.disc_teaching8?.main_second_user_name"
        }
      },
      "seq": 502,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 503,
      "name": "Input",
      "parent": 236,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-Input-503"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeValue(\"disc_teaching2.main_home_user_name\")"
        },
        "style": {
          "type": "code",
          "value": "{width:\"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.ClinicalTermTeaching?.disc_teaching2?.main_home_user_name"
        }
      },
      "seq": 503,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 504,
      "name": "Input",
      "parent": 259,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-Input-504"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeValue(\"disc_teaching3.main_home_user_name\")"
        },
        "style": {
          "type": "code",
          "value": "{width:\"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.ClinicalTermTeaching?.disc_teaching3?.main_home_user_name"
        }
      },
      "seq": 504,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 505,
      "name": "Input",
      "parent": 282,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-Input-505"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeValue(\"disc_teaching4.main_home_user_name\")"
        },
        "style": {
          "type": "code",
          "value": "{width:\"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.ClinicalTermTeaching?.disc_teaching4?.main_home_user_name"
        }
      },
      "seq": 505,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 506,
      "name": "Input",
      "parent": 305,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-Input-506"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeValue(\"disc_teaching5.main_home_user_name\")"
        },
        "style": {
          "type": "code",
          "value": "{width:\"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.ClinicalTermTeaching?.disc_teaching5?.main_home_user_name"
        }
      },
      "seq": 506,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 507,
      "name": "Input",
      "parent": 328,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-Input-507"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeValue(\"disc_teaching6.main_home_user_name\")"
        },
        "style": {
          "type": "code",
          "value": "{width:\"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.ClinicalTermTeaching?.disc_teaching6?.main_home_user_name"
        }
      },
      "seq": 507,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 508,
      "name": "Input",
      "parent": 351,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-Input-508"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeValue(\"disc_teaching7.main_home_user_name\")"
        },
        "style": {
          "type": "code",
          "value": "{width:\"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.ClinicalTermTeaching?.disc_teaching7?.main_home_user_name"
        }
      },
      "seq": 508,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 509,
      "name": "Input",
      "parent": 374,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-Input-509"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeValue(\"disc_teaching7.items.0.sub_home_user_name\")"
        },
        "style": {
          "type": "code",
          "value": "{width:\"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.ClinicalTermTeaching?.disc_teaching7?.items?.[0]?.sub_home_user_name"
        }
      },
      "seq": 509,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 510,
      "name": "Input",
      "parent": 397,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-Input-510"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeValue(\"disc_teaching7.items.1.sub_home_user_name\")"
        },
        "style": {
          "type": "code",
          "value": "{width:\"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.ClinicalTermTeaching?.disc_teaching7?.items?.[1]?.sub_home_user_name"
        }
      },
      "seq": 510,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 511,
      "name": "Input",
      "parent": 420,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-Input-511"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeValue(\"disc_teaching7.items.2.sub_home_user_name\")"
        },
        "style": {
          "type": "code",
          "value": "{width:\"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.ClinicalTermTeaching?.disc_teaching7?.items?.[2]?.sub_home_user_name"
        }
      },
      "seq": 511,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 512,
      "name": "Input",
      "parent": 443,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDischargeTeachingUX-Input-512"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeValue(\"disc_teaching8.main_home_user_name\")"
        },
        "style": {
          "type": "code",
          "value": "{width:\"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.ClinicalTermTeaching?.disc_teaching8?.main_home_user_name"
        }
      },
      "seq": 512,
      "void": false
    }
  ],
  "forwardRef": false,
  "height": 85,
  "isMounted": false,
  "memo": false,
  "name": "CardDischargeTeachingUX",
  "project": "IsHealth",
  "screenPropsDefault": {
    "drugSearch": "[Drug Search Box]"
  },
  "width": 95
}

*********************************************************************************** */
